/** @format */
import { GrCode } from "react-icons/gr";
import { FaApple, FaLink } from "react-icons/fa6";
import { SiFlutter } from "react-icons/si";
import { AiFillAndroid } from "react-icons/ai";
import { FaMagnifyingGlass } from "react-icons/fa6";
import {
  TbDeviceMobileCode,
  TbDeviceMobilePlus,
  TbBrandReactNative,
} from "react-icons/tb";
import { FaLaptopCode } from "react-icons/fa";
import { GiPencilBrush, GiRobotAntennas, GiTv } from "react-icons/gi";
import { FaLaptopMedical } from "react-icons/fa6";
import { CgWebsite } from "react-icons/cg";
import { BsCloudArrowUpFill } from "react-icons/bs";
import { TbDeviceImacCog } from "react-icons/tb";
import { GrTechnology } from "react-icons/gr";
import { SiOpenai } from "react-icons/si";
import { LuBoxes } from "react-icons/lu";
import { RiNftFill } from "react-icons/ri";
import { FaWallet } from "react-icons/fa";
import { GiToken } from "react-icons/gi";
import { RxUpdate } from "react-icons/rx";
import { BiSupport } from "react-icons/bi";
import { TbCloudComputing } from "react-icons/tb";
import { TiFlowChildren } from "react-icons/ti";
import { PiVirtualRealityFill } from "react-icons/pi";
import { MdAutoFixHigh } from "react-icons/md";

export const our_services = [
  {
    name: "Staff Augmentation",
    count: "01",
    description:
      "We let you hire the expertise your team needs to scale productivity, without the hassles of a long recruitment process",
  },
  {
    name: "Bespoke Web and Mobile Apps",
    count: "02",
    description:
      " We ensure rich customer experiences by developing personalized applications that fully utilize power and flexibility",
  },
  {
    name: "Custom Software Solutions",
    count: "03",
    description:
      "We surpass at providing high-tech enterprise software services that are highly-responsive & outstandingly designed",
  },
];

export const header_options = [
  { name: "Home", route: "home" },
  { name: "Company", route: "company" },
  {
    name: "Services",
    route: "services?name=Mobile_App_Development",
    types: true,
  },
  { name: "Portfolio", route: "portfolio" },
  { name: "Blog", route: "blogs" },
  { name: "Careers", route: "careers" },
  { name: "Startup", route: "start-up" },
  // { name: "Hire Developer", route: "hire-developer" },
];
export const services_types = [
  {
    name: "Mobile App Development",
    route: "services?name=Mobile_App_Development",
  },
  { name: "Web App Development", route: "services?name=Web_App_Development" },
  { name: "AI/ML Development", route: "services?name=AI_ML_Development" },
  {
    name: "Blockchain Development",
    route: "services?name=Blockchain_Development",
  },
  { name: "OTT App Development", route: "services?name=OTT_App_Development" },
  {
    name: "Cloud App Development",
    route: "services?name=Cloud_App_Development",
  },
  { name: "DevOps Consulting", route: "services?name=DevOps_Consulting" },
];

export const build_or_buy = [
  {
    name: "",
    heading: "Healthcare",
    details:
      " Specializing in digital health and ensuring HIPAA compliance, we provide secure healthcare software solutions including patient management, telehealth apps, and EHR/EMS systems.",
  },
  {
    name: "",
    heading: "Fintech",
    details:
      " Revolutionize your financial services with our innovative software solutions. Enhance security, efficiency, and customer satisfaction. Let’s shape the future of fintech together.",
  },
  {
    name: "",
    heading: "Edtech",
    details:
      "Transform education with our innovative edtech solutions. Improve student engagement, accessibility, and outcomes. Together, let's shape the future of learning.",
  },
  {
    name: "",
    heading: "Retail",
    details: " Revolutionize retail operations and consumer experiences.",
  },
];

export const home_header_images = [
  {
    image: "images/home01.webp",
  },
  {
    image: "images/home02.webp",
  },
  {
    image: "images/home03.webp",
  },
];

export const services_header_images = [
  {
    image: "images/MacBook Pro 16-inch Space Black Front.png",
  },
  {
    image: "images/smartcom1.png",
  },
  {
    image: "images/almana1.png",
  },
  {
    image: "images/ServiceHeroImage.svg",
  },
];
export const OurClients_images = [
  {
    image: "images/Clip path group.svg",
  },
  {
    image: "images/Screenshot_2024-03-28_at_2 1.svg",
  },
  {
    image: "images/almana2.png",
  },
  {
    image: "images/Frame 148.png",
  },
  {
    image: "images/Sendoso-Logo-Header 1.svg",
  },
  {
    image: "images/Wajda-Logo 2 (1).svg",
  },
];

export const our_achievements = [
  {
    count: "9+",
    heading: "Years of Growth 🚀",
    details:
      "From x to a full development team with steady growth and value delivery",
  },
  {
    count: "10+",
    heading: "Industries 💼",
    details:
      "We’ve developed digital products for the hottest industries out there",
  },
  {
    count: " 500+",
    heading: "Projects Delivered ✅",
    details:
      "We ensure that your project has the tools and processes needed to succeed",
  },
  {
    count: "90%",
    heading: "Client Retention 🤩",
    details:
      "We gain customer trust with excellent communication and high-quality services",
  },
];
export const leaderShips = [
  {
    name: "Yasir Aziz",
    image: "images/yasir.jpg",
    designation: "CEO and Founder",
    color: "#FF5D52",
    linkedin: "https://www.linkedin.com/in/muhammadyasir/",
  },
  {
    name: "Fawad Naeem",
    image: "images/img_image50.png",
    designation: "Technology Advisor",
    color: "#FFCC01",
    linkedin: "https://www.linkedin.com/in/fawadnaeem/",
  },
  {
    name: "Usman Saeed",
    image: "images/usman.jpg",
    designation: "Engagement Manager | Project Manager",
    color: "#56DE7D",
    linkedin: "https://www.linkedin.com/in/musmansaeed91/",
  },
  {
    name: "SA Shahzad",
    image: "images/shahzad.jpg",
    designation: "Director Sales & Marketing",
    color: "#56DE7D",
    linkedin: "https://www.linkedin.com/in/ahmad-shahzad-24636232/",
  },
  {
    name: "Shahzaib Saleem",
    image: "images/shahzab.jpg",
    designation: "Big Data Analytics | E-Commerce Expert",
    color: "#00B7E9",
    linkedin: "https://www.linkedin.com/in/shahzaib-saleem-b094347/",
  },
  {
    name: "Sohail Mohabbat Ali",
    image: "images/sohail.jpg",
    designation: "Senior Software Architect",
    color: "#E3285F",
    linkedin: "https://www.linkedin.com/in/sohail-mohabbat-ali-32b2242b/",
  },

  {
    name: "Muhammad Anser",
    image: "images/anser.jpg",
    designation: "Software Architect",
    color: "#FFCC01",
    linkedin: "https://www.linkedin.com/in/muhammad-anser/",
  },
];

export const outsource_development = [
  {
    name: "",
    heading: "Real Estate",
    details:
      " Revolutionize your real estate business with custom software solutions. Enhance efficiency, streamline operations, and gain a competitive edge. Partner with us for your success.",
  },
  {
    name: "",
    heading: "eCommerce",
    details:
      " Our customized software solutions can elevate your e-commerce business. They improve user experience, streamline operations, and boost sales. Partner with us for e-commerce success.",
  },
  {
    name: "",
    heading: "Gaming",
    details:
      "Enhance your gaming experience with our custom software solutions. Improve gameplay graphics and user engagement. Together, let's create an immersive gaming world.",
  },
];

export const services = [
  {
    name: "Mobile Development",
    route: "service-details?name=Mobile Development",
  },
  { name: "Web Applications", route: "service-details?name=Web Development" },
  { name: "UI/UX Designs", route: "service-details?name=Product Design" },
  { name: "DevOps", route: "service-details?name=DevOps" },
  { name: "Q/A Services", route: "service-details?name=Quality Assurance" },
];

export const resources = [
  { name: "Blog", route: "blogs" },
  { name: "Case Studies", route: "portfolio" },
  { name: "Careers", route: "careers" },
];
export const contact_us = [
  { name: "Pakistan:", route: "home" },
  { name: "46 Block B PCSIR 2", route: "home" },
  { name: "Johar Town Lahore", route: "home" },
  { name: "+92 42 35315822", route: "home" },
  { name: "", route: "home" },
  { name: "UK:", route: "home" },
  { name: "9 College Drive", route: "home" },
  { name: "Dunstable LU5 4 NB", route: "home" },
  { name: "+44 7468434033", route: "home" },
];

export const whyCardsData = [
  {
    image: "images/img_frame135.svg",
    heading: "Virtuous Partnerships",
    details:
      "Customer prosperity is our priority ad we go extra-miles to tackle issues our customers are confronting with their digital innovation execution",
  },
  {
    image: "images/img_frame61.svg",
    heading: "Exceeding Expectations",
    details:
      "We believe that every task or situation an opportunity to go above and beyond what is expected by our clients and stakeholders",
  },
  {
    image: "images/img_frame244.svg",
    heading: "Assured Quality",
    details:
      "We never settle for less, and with integrated quality assurance processes, we ensure that your products are market-ready before launch",
  },
  {
    image: "images/img_crop.svg",
    heading: "Customization",
    details:
      "We develop software services to meet the unique needs of each client, with our highly flexible process that adapts to changing requirements",
  },
];

export const TeamCardData = [
  {
    image: "images/teamyellow.png",
    heading: "Select the Right Expert",
    shadow: "#FFCC01",
    details:
      "Handpick from our talent pool, ensuring that you have the right expertise tailored to your project's needs.",
  },
  {
    image: "images/teamgreen.png",
    heading: "Kick Off with an Introductory Interview",
    details:
      "Engage directly with potential team members. This step ensures a perfect fit in terms of skills and project requirements.",
    shadow: "#56DE7D",
  },
  {
    image: "images/teamblue.png",
    heading: "Onboard Developers Promptly",
    details:
      "We value your time. With our streamlined process, you can have developers on your project in no time.",
    shadow: "#00A0CC",
  },
];

export const CoreValuesData = [
  {
    image: "images/exceed.png",
    heading: "Exceed client expectations",
    details:
      "We build trust by ensuring that the clients’ needs and requirements are met and exceeded in every project",
  },
  {
    image: "images/foster.png",
    heading: " Foster a collaborative environment",
    details:
      "Our team works closely with clients and colleagues  to foster a culture of synergy and open communication",
  },
  {
    image: "images/maintain.png",
    heading: "Maintain continuous accountability",
    details:
      "Our developers take ownership of individual and team responsibilities and deliver timely on commitments",
  },
];
export const job_openings = [
  {
    position: "IOS Developer",
    location: "United States",
    time: "Full Time",
  },
  {
    position: ".NET Cloud Developer",
    location: "United States",
    time: "Full Time",
  },
  {
    position: "Front-end Developer",
    location: "Pakistan",
    time: "Full Time",
  },
];

export const domain_experience = {
  icon: "images/DomainExperience.webp",
  heading: "Domain Experience",
  detail:
    "We provide you the best IT professionals with sufficient domain experience to fill your skills gap and improve your product quality",
};
export const product_growth = {
  icon: "images/ProductGrowth.webp",
  heading: "Product Growth",
  detail:
    "Our goal is to make your product growth skyrocket. We’re all about hitting your KPIs. That means no fluff, no excuses, ever",
};
export const faster_launch = {
  icon: "images/FasterLaunchTimes.webp",
  heading: "Faster Launch Times",
  detail:
    "Through customer centric design and best-in-class software development, our teams help you to bring your ideas to market, faster",
};
export const process_visibility = {
  icon: "images/ProcessVisibilty.webp",
  heading: "Process Visibility",
  detail:
    "We combine accessibility, flexibility and integration to derive process visibility dimensions from information quality",
};
export const website_development = {
  heading: "Website Development",
  details:
    "Our web applications are profoundly versatile, empowering the finest client involvement in any case of the measure of their screen",
  icons_data: [
    {
      icon: "images/java23.svg",
      heading: "Java",
    },
    {
      icon: " images/node23.png",
      heading: "Node Js",
    },
    {
      icon: "images/angular23.svg",
      heading: "Angular",
    },
    {
      icon: "images/js23.svg",
      heading: "JavaScript",
    },
    {
      icon: "images/jquery23.png",
      heading: "Jqeury",
    },
    {
      icon: "images/bootstrap23.svg",
      heading: "Bootstrap",
    },
    {
      icon: "images/firbase23.png",
      heading: "Firebase",
    },
    {
      icon: "images/rails23.svg",
      heading: "ROR",
    },
    {
      icon: "images/mongo23.svg",
      heading: "MongoDB",
    },
    {
      icon: "images/sql23.png",
      heading: "SQlite",
    },
  ],
};
export const mobile_development = {
  heading: "Mobile Development",
  details:
    "We use best industry technologies and practices that assist you in making a product that delights your clients",
  icons_data: [
    {
      icon: "images/andriod23.png",
      heading: "Android",
    },
    {
      icon: " images/apple23.png",
      heading: "IOS",
    },
    {
      icon: "images/flutter23.png",
      heading: "Flutter",
    },
    {
      icon: "images/react23.png",
      heading: "React-Native",
    },
    {
      icon: "images/node23.png",
      heading: "Node Js",
    },
  ],
};
export const product_design = {
  heading: "Product Design",
  details:
    "We implement UI/UX design and advancement, to make your solutions have an eye-filling look and behaviour. This will assist you to extend future item appropriation",
  icons_data: [
    {
      icon: "images/Figma.svg",
      heading: "Figma",
    },
    {
      icon: " images/protoio23.svg",
      heading: "Proto.io",
    },
    {
      icon: "images/adobe23.png",
      heading: "Adobe Xd",
    },
    {
      icon: "images/Maze.svg",
      heading: "Maze",
    },
    {
      icon: "images/miro23.png",
      heading: "Miro",
    },
  ],
};
export const dev_ops = {
  heading: "DevOps",
  details:
    "Our experienced DevOps consultants improve your services using latest tech",
  icons_data: [
    {
      icon: "images/img_9073807azureicon.svg",
      heading: "Azure",
    },
    {
      icon: " images/img_8546827awsicon.svg",
      heading: "AWS",
    },
    {
      icon: "images/docker23.svg",
      heading: "Docker",
    },
  ],
};

export const Mobile_App_Development_Services = [
  {
    image: (
      <svg
        width="45px"
        height="50px"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke="#CCCCCC"
          stroke-width="0.288"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            d="M7 8L3 11.6923L7 16M17 8L21 11.6923L17 16M14 4L10 20"
            stroke="#000000"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>{" "}
        </g>
      </svg>
    ),
    title: "Healthcare",
    color: "#56DE7D",
    description: "Navigate the digital landscape with bespoke software.",
  },
  {
    image: (
      <svg
        width="45px"
        height="50px"
        fill="#000000"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path d="M 5 6 L 5 19.5625 L 2.71875 21.876953 C 2.26575 22.328953 2 22.95275 2 23.59375 C 2 24.91375 3.08625 26 4.40625 26 L 27.59375 26 C 28.91375 26 30 24.91375 30 23.59375 C 30 22.95275 29.73425 22.328 29.28125 21.875 L 27 19.5625 L 27 6 L 5 6 z M 7 8 L 25 8 L 25 19 L 7 19 L 7 8 z M 16 9 L 14.5 18 L 16 18 L 17.5 9 L 16 9 z M 12.085938 11 L 10.367188 13.068359 L 10 13.5 L 10.367188 13.931641 L 12.085938 16 L 13.171875 15.136719 L 11.810547 13.5 L 13.171875 11.863281 L 12.085938 11 z M 19.914062 11 L 18.828125 11.863281 L 20.189453 13.5 L 18.828125 15.136719 L 19.914062 16 L 21.632812 13.931641 L 22 13.5 L 21.632812 13.068359 L 19.914062 11 z M 6.4375 21 L 25.5625 21 L 27.875 23.28125 C 27.953 23.35925 28 23.48375 28 23.59375 C 28 23.83575 27.83575 24 27.59375 24 L 4.40625 24 C 4.16425 24 4 23.83575 4 23.59375 C 4 23.48475 4.047 23.36025 4.125 23.28125 L 6.4375 21 z"></path>
        </g>
      </svg>
    ),
    title: "Education",
    color: "#DE568F",
    description: "Navigate the digital landscape with bespoke software.",
  },
  {
    image: (
      <svg
        width="45px"
        height="50px"
        fill="#000000"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>ios</title>{" "}
          <path d="M1.119 12.633v10.576h2.49v-10.576h-2.49zM11.882 10.768c2.553 0 4.193 2.040 4.193 5.232 0 3.217-1.64 5.257-4.193 5.257-2.578 0-4.206-2.040-4.206-5.257 0-3.192 1.627-5.232 4.206-5.232zM25.45 8.578c-3.129 0-5.357 1.727-5.357 4.293 0 2.040 1.264 3.317 3.918 3.93l1.865 0.451c1.815 0.413 2.553 1.014 2.553 2.053 0 1.202-1.214 2.053-2.941 2.053-1.765 0-3.092-0.864-3.229-2.19h-2.503c0.1 2.654 2.278 4.281 5.582 4.281 3.492 0 5.683-1.715 5.683-4.443 0-2.14-1.252-3.354-4.155-4.018l-1.665-0.376c-1.765-0.426-2.491-0.989-2.491-1.94 0-1.202 1.101-2.003 2.729-2.003 1.64 0 2.766 0.814 2.891 2.153h2.453c-0.063-2.528-2.153-4.243-5.332-4.243zM11.882 8.578c-4.205-0-6.834 2.866-6.834 7.422 0 4.594 2.628 7.447 6.834 7.447 4.181 0 6.821-2.854 6.821-7.447 0-4.556-2.641-7.422-6.822-7.422zM2.357 8.553c-0.007-0-0.016-0-0.024-0-0.747 0-1.352 0.605-1.352 1.352s0.605 1.352 1.352 1.352c0.009 0 0.017-0 0.026-0l-0.001 0c0.011 0 0.024 0.001 0.037 0.001 0.747 0 1.352-0.605 1.352-1.352s-0.605-1.352-1.352-1.352c-0.013 0-0.026 0-0.039 0.001l0.002-0z"></path>{" "}
        </g>
      </svg>
    ),
    title: "Real Estate",
    color: "#DEC056",
    description: "Navigate the digital landscape with bespoke software.",
  },
  {
    image: (
      <svg
        width="45px"
        height="50px"
        fill="#000000"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        enable-background="new 0 0 512 512"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <g id="b75708d097f2188dff6617b0f00f7c43">
            {" "}
            <path
              display="inline"
              d="M120.606,169h270.788v220.663c0,13.109-10.628,23.737-23.721,23.737h-27.123v67.203 c0,17.066-13.612,30.897-30.415,30.897c-16.846,0-30.438-13.831-30.438-30.897v-67.203h-47.371v67.203 c0,17.066-13.639,30.897-30.441,30.897c-16.799,0-30.437-13.831-30.437-30.897v-67.203h-27.099 c-13.096,0-23.744-10.628-23.744-23.737V169z M67.541,167.199c-16.974,0-30.723,13.963-30.723,31.2v121.937 c0,17.217,13.749,31.204,30.723,31.204c16.977,0,30.723-13.987,30.723-31.204V198.399 C98.264,181.162,84.518,167.199,67.541,167.199z M391.395,146.764H120.606c3.342-38.578,28.367-71.776,64.392-90.998 l-25.746-37.804c-3.472-5.098-2.162-12.054,2.946-15.525c5.102-3.471,12.044-2.151,15.533,2.943l28.061,41.232 c15.558-5.38,32.446-8.469,50.208-8.469c17.783,0,34.672,3.089,50.229,8.476L334.29,5.395c3.446-5.108,10.41-6.428,15.512-2.957 c5.108,3.471,6.418,10.427,2.946,15.525l-25.725,37.804C363.047,74.977,388.055,108.175,391.395,146.764z M213.865,94.345 c0-8.273-6.699-14.983-14.969-14.983c-8.291,0-14.99,6.71-14.99,14.983c0,8.269,6.721,14.976,14.99,14.976 S213.865,102.614,213.865,94.345z M329.992,94.345c0-8.273-6.722-14.983-14.99-14.983c-8.291,0-14.97,6.71-14.97,14.983 c0,8.269,6.679,14.976,14.97,14.976C323.271,109.321,329.992,102.614,329.992,94.345z M444.48,167.156 c-16.956,0-30.744,13.984-30.744,31.222v121.98c0,17.238,13.788,31.226,30.744,31.226c16.978,0,30.701-13.987,30.701-31.226 v-121.98C475.182,181.14,461.458,167.156,444.48,167.156z"
            >
              {" "}
            </path>{" "}
          </g>{" "}
        </g>
      </svg>
    ),
    title: "Travel",
    color: "#DE568F",
    description: "Navigate the digital landscape with bespoke software.",
  },
  {
    image: (
      <svg
        width="45px"
        height="50px"
        fill="#000000"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <title>flutter</title>{" "}
          <path d="M18.909 14.84l-8.086 8.070 8.085 8.085h9.214l-8.073-8.083 8.073-8.073h-9.212zM18.892 1.004l-15.013 14.996 4.624 4.624 19.599-19.603h-9.194z"></path>{" "}
        </g>
      </svg>
    ),
    title: "Finance",
    color: "#9256DE",
    description: "Navigate the digital landscape with bespoke software.",
  },
  {
    image: (
      <svg
        width="45px"
        height="50px"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          {" "}
          <path
            fill-rule="nonzero"
            clip-rule="nonzero"
            d="M4.84989 2.37195C4.59895 2.51683 4.33488 2.91636 4.30424 3.78785C4.28968 4.20181 3.9423 4.52559 3.52835 4.51103C3.11439 4.49647 2.79061 4.1491 2.80516 3.73514C2.84273 2.66673 3.1806 1.60366 4.09989 1.07291C5.02179 0.540653 6.11484 0.782356 7.06128 1.28727C7.42674 1.48224 7.56495 1.93656 7.36998 2.30201C7.17501 2.66747 6.72069 2.80568 6.35524 2.61072C5.5818 2.1981 5.10158 2.22663 4.84989 2.37195ZM8.87139 3.67284C9.19036 3.40858 9.66315 3.45293 9.92741 3.7719C10.4818 4.44103 11.0136 5.20405 11.4963 6.04018C12.5366 7.84191 13.178 9.68785 13.3509 11.2362C13.4372 12.0091 13.4108 12.7446 13.2303 13.3754C13.0484 14.011 12.6941 14.5863 12.0999 14.9293C11.381 15.3444 10.5509 15.2855 9.79114 15.0089C9.02868 14.7313 8.24395 14.2056 7.49586 13.5228C7.18993 13.2435 7.16831 12.7691 7.44756 12.4632C7.72681 12.1573 8.20119 12.1356 8.50712 12.4149C9.16624 13.0165 9.78567 13.4105 10.3043 13.5994C10.8257 13.7892 11.1537 13.7436 11.3499 13.6303C11.5143 13.5354 11.6797 13.342 11.7882 12.9627C11.8981 12.5787 11.9328 12.0529 11.8602 11.4026C11.7152 10.1045 11.1591 8.45607 10.1973 6.79018C9.75492 6.02396 9.27081 5.33055 8.77232 4.72886C8.50807 4.40989 8.55242 3.93709 8.87139 3.67284Z"
            fill="#000000"
          ></path>{" "}
          <path
            fill-rule="nonzero"
            clip-rule="nonzero"
            d="M14.5 8.20557C14.5 7.91581 14.286 7.48735 13.5466 7.02507C13.1954 6.80549 13.0887 6.34276 13.3083 5.99154C13.5279 5.64032 13.9906 5.53361 14.3418 5.75319C15.2483 6.31993 16 7.14407 16 8.20557C16 9.27009 15.2442 10.0958 14.3337 10.663C13.9821 10.882 13.5195 10.7746 13.3005 10.423C13.0815 10.0714 13.189 9.60887 13.5405 9.38985C14.2846 8.92635 14.5 8.4962 14.5 8.20557ZM11.3626 11.0378C11.432 11.4462 11.1572 11.8335 10.7488 11.9029C9.89219 12.0484 8.96547 12.1274 8 12.1274C5.91954 12.1274 4.00018 11.76 2.57286 11.1355C1.86032 10.8238 1.23659 10.4332 0.780529 9.9615C0.320977 9.48616 0 8.89166 0 8.20557C0 7.37549 0.466082 6.68599 1.08548 6.16636C1.70712 5.64485 2.55471 5.22808 3.52013 4.92164C3.91494 4.79633 4.33657 5.01479 4.46189 5.40959C4.5872 5.80439 4.36874 6.22603 3.97394 6.35135C3.12334 6.62134 2.4724 6.96078 2.04954 7.31553C1.62442 7.67217 1.5 7.97899 1.5 8.20557C1.5 8.39536 1.58476 8.6353 1.85895 8.91891C2.13663 9.20613 2.57464 9.49905 3.17409 9.76131C4.37076 10.2848 6.07639 10.6274 8 10.6274C8.88475 10.6274 9.72732 10.5549 10.4976 10.424C10.906 10.3547 11.2933 10.6295 11.3626 11.0378Z"
            fill="#000000"
          ></path>{" "}
          <path
            fill-rule="nonzero"
            clip-rule="nonzero"
            d="M4.87192 13.6303C5.12286 13.7752 5.6009 13.8041 6.37095 13.3949C6.73673 13.2005 7.19082 13.3395 7.38519 13.7052C7.57957 14.071 7.44062 14.5251 7.07484 14.7195C6.13079 15.2211 5.04121 15.4601 4.12192 14.9293C3.20003 14.3971 2.86282 13.3296 2.82687 12.2575C2.81299 11.8435 3.13733 11.4967 3.55131 11.4828C3.96529 11.4689 4.31215 11.7932 4.32603 12.2072C4.35541 13.0834 4.62023 13.485 4.87192 13.6303ZM3.98778 9.49712C3.59944 9.35301 3.40145 8.92138 3.54556 8.53304C3.84786 7.71839 4.24274 6.8763 4.72548 6.04018C5.76571 4.23845 7.04361 2.75996 8.29806 1.83609C8.92431 1.37487 9.57441 1.02999 10.211 0.870901C10.8524 0.71059 11.5278 0.729863 12.1219 1.07291C12.8408 1.48795 13.2049 2.23634 13.3452 3.03257C13.486 3.83168 13.4232 4.77409 13.2058 5.7634C13.1169 6.16796 12.7169 6.42388 12.3124 6.33501C11.9078 6.24613 11.6519 5.84612 11.7408 5.44155C11.9322 4.56992 11.9637 3.83647 11.868 3.29288C11.7717 2.7464 11.5681 2.48524 11.3719 2.37195C11.2076 2.27705 10.9574 2.23049 10.5747 2.32614C10.1871 2.42301 9.71442 2.65588 9.18757 3.04388C8.13584 3.81846 6.98632 5.12428 6.02452 6.79018C5.58214 7.55639 5.22369 8.32235 4.95185 9.0549C4.80774 9.44323 4.37611 9.64122 3.98778 9.49712Z"
            fill="#000000"
          ></path>{" "}
          <path
            d="M9.45925 8.06618C9.45925 8.81694 8.85063 9.42556 8.09987 9.42556C7.34911 9.42556 6.7405 8.81694 6.7405 8.06618C6.7405 7.31542 7.34911 6.70681 8.09987 6.70681C8.85063 6.70681 9.45925 7.31542 9.45925 8.06618Z"
            fill="#000000"
          ></path>{" "}
        </g>
      </svg>
    ),
    title: "Wellness & Fitness",
    color: "#56DE7D",
    description: "Navigate the digital landscape with bespoke software.",
  },
];

export const areas_of_expertise = [
  {
    id: 1,
    title: "Patient Management",
    image: "images/material-symbols_patient-list-rounded.png",
    subHeading: "Find a doctor, Hospital, or Specialty.",
    color: "#5AC7DE",
  },
  {
    id: 2,
    title: "Tele Health Consultation",
    image: "images/Group 7131.png",
    subHeading: "Offering you accessible, reliable, convenient healthcare.",
    color: "#56DE7D",
  },
  {
    id: 3,
    title: "Hospital Management",
    image: "images/Group 7130.png",
    subHeading:
      "View profile, attendance, leave, payroll, Reporting & Analytics.",
    color: "#FFC700",
  },
  {
    id: 4,
    title: "Fleet Management System",
    image: "images/Vector (1).png",
    subHeading:"Offering real time monitoring, Alerts for vehicle maintenance, Cost analysis & Optimization.",
    color: "#9256DE",
  },
];

export const gaming_expertise = [
  {
    id: 1,
    title: "ART WORK",
    image: "images/material-symbols-light_work-update.png",
    subHeading:
      "Craft intricate 2D/3D designs, including character modelling, environmental art, and animations for games and applications.",
    color: "#5AC7DE",
  },
  {
    id: 2,
    title: "GAME OPTIMIZATION",
    image: "images/Optimization.png",
    subHeading:
      "Improving performance, graphics, and resource usage to optimize games for different devices and platforms.",
    color: "#56DE7D",
  },
  {
    id: 3,
    title: "GAMES DEVELOPMENT",
    image: "images/coding.webp",
    subHeading:
      "Development services for 2D/3D games, including offline/multiplayer experiences, with captivating graphics for cross-platform deployment.",
    color: "#FFC700",
  },
  {
    id: 4,
    title: "2D/3D ANIMATION",
    image: "images/mdi_animation-play.png",
    subHeading:
      "Bring your ideas to life with professional animation services, enhancing the impact and appeal of your projects",
    color: "#9256DE",
  },
];

export const  eCommerce_expertise = [
  {
    id: 1,
    title: "Customer Relationship Management (CRM)",
    image: "images/crm.webp",
    subHeading:
      "Systems that manage customer interactions, data, and relationships to enhance customer service and retention.",
    color: "#5AC7DE",
  },
  {
    id: 2,
    title: "Logistics and Fulfillment",
    image: "images/fulfillment.webp",
    subHeading:
      "Services that handle product storage, packing, and shipping to customers. This includes partnerships with shipping carriers.",
    color: "#56DE7D",
  },
  {
    id: 3,
    title: "Data Analytics",
    image: "images/analytics.webp",
    subHeading:
      "Tools that analyze customer behavior and sales data to inform business decisions and improve marketing strategies.",
    color: "#FFC700",
  },
  {
    id: 4,
    title: "Payment Processing",
    image: "images/payment.webp",
    subHeading:
      "Services that facilitate online transactions, ensuring secure payment methods. Examples include PayPal, Stripe, and Square.",
    color: "#9256DE",
  },
];

export const our_mission = [
  {
    heading: "Our Mission",
    details:
      "Our mission is to enhance business growth of our customers with creative design, development and to deliver market defining high quality solutions that create value and reliable competitive advantage to customers around the globe.",
    detail2:
      "Our competencies are always kept up with any technology change, so we offer you latest trends in the industry.",
    image: "images/img_image46.png",
  },
  {
    heading: "Our Vision",
    details:
      "Our vision is to create innovative software solutions that solve complex problems and improve the lives of people. The company strives to be a leader in the industry by providing high-quality software products that are reliable, secure, and user-friendly.",
    image: "images/Picture.jpg",
  },
];

export const export_list_icones = [
  {
    name: "MySQL",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 53 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={isActive ? "#424A60" : "#A9A9A9"}
          d="M50.455,8L50.455,8C49.724,3.538,39.281,0,26.5,0S3.276,3.538,2.545,8l0,0H2.5v0.5V20v0.5V21v11v0.5
	V33v12h0.045c0.731,4.461,11.175,8,23.955,8s23.224-3.539,23.955-8H50.5V33v-0.5V32V21v-0.5V20V8.5V8H50.455z"
        />
        <g>
          <path
            fill={isActive ? "#424A60" : "#A9A9A9"}
            d="M26.5,41c-13.255,0-24-3.806-24-8.5V45h0.045c0.731,4.461,11.175,8,23.955,8s23.224-3.539,23.955-8
		H50.5V32.5C50.5,37.194,39.755,41,26.5,41z"
          />
          <path
            fill={isActive ? "#424A60" : "#A9A9A9"}
            d="M2.5,32v0.5c0-0.168,0.018-0.334,0.045-0.5H2.5z"
          />
          <path
            fill={isActive ? "#424A60" : "#A9A9A9"}
            d="M50.455,32c0.027,0.166,0.045,0.332,0.045,0.5V32H50.455z"
          />
        </g>
        <g>
          <path
            fill={isActive ? "#556080" : "#fff"}
            d="M26.5,29c-13.255,0-24-3.806-24-8.5V33h0.045c0.731,4.461,11.175,8,23.955,8s23.224-3.539,23.955-8
		H50.5V20.5C50.5,25.194,39.755,29,26.5,29z"
          />
          <path
            fill={isActive ? "#556080" : "#A9A9A9"}
            d="M2.5,20v0.5c0-0.168,0.018-0.334,0.045-0.5H2.5z"
          />
          <path
            fill={isActive ? "#556080" : "#A9A9A9"}
            d="M50.455,20c0.027,0.166,0.045,0.332,0.045,0.5V20H50.455z"
          />
        </g>
        <ellipse
          fill={isActive ? "#7FABDA" : "#A9A9A9"}
          cx="26.5"
          cy="8.5"
          rx="24"
          ry="8.5"
        />
        <g>
          <path
            fill={isActive ? "#7383BF" : "#A9A9A9"}
            d="M26.5,17c-13.255,0-24-3.806-24-8.5V21h0.045c0.731,4.461,11.175,8,23.955,8s23.224-3.539,23.955-8
		H50.5V8.5C50.5,13.194,39.755,17,26.5,17z"
          />
          <path
            fill={isActive ? "#7383BF" : "#A9A9A9"}
            d="M2.5,8v0.5c0-0.168,0.018-0.334,0.045-0.5H2.5z"
          />
          <path
            fill={isActive ? "#7383BF" : "#A9A9A9"}
            d="M50.455,8C50.482,8.166,50.5,8.332,50.5,8.5V8H50.455z"
          />
        </g>{" "}
      </svg>
    ),
    originalFill: "#00758F",
  },
  {
    name: "PostgreSQL",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={isActive ? "#fff" : "#fff"}
          d="M44.083,29.79c-0.183-0.829-0.935-1.796-2.452-1.796c-0.31,0-0.649,0.039-1.035,0.119c-0.708,0.146-1.311,0.217-1.842,0.241c4.133-7.04,6.816-16.819,4.159-20.214c-3.501-4.473-8.214-5.141-10.711-5.141L31.967,3c-0.929,0.015-1.893,0.129-2.863,0.339l-3.583,0.774C25.033,4.052,24.536,4.009,24.018,4l-0.03,0l-0.016,0l-0.152-0.001c-1.593,0-3.046,0.338-4.341,0.973l-1.251-0.493c-1.72-0.678-4.308-1.485-6.868-1.485c-0.144,0-0.287,0.003-0.431,0.008C8.407,3.093,6.241,4.05,4.664,5.769C2.696,7.915,1.8,11.054,2.003,15.1C2.013,15.309,4.461,36,11.4,36h0.025l0.064-0.001c0.901-0.022,1.76-0.384,2.563-1.077c0.613,0.46,1.406,0.732,2.145,0.84c0.488,0.115,1.366,0.278,2.418,0.278c1.284,0,2.442-0.263,3.44-0.738c-0.001,0.88-0.006,1.994-0.016,3.418l-0.001,0.075l0.005,0.075c0.097,1.419,0.342,2.698,0.711,3.701c1.051,2.859,2.866,4.434,5.111,4.434c0.093,0,0.188-0.003,0.284-0.009c1.846-0.114,3.717-1.151,5.004-2.772c1.393-1.755,1.715-3.607,1.839-5.026L35,39.111v-0.088v-4.079l0.103,0.01l0.436,0.038l0.042,0.004l0.042,0.002c0.124,0.006,0.252,0.008,0.381,0.008c1.507,0,3.362-0.391,4.616-0.974C41.819,33.476,44.559,31.948,44.083,29.79z"
        />
        <path
          fill={isActive ? "#0277bd" : "#A9A9A9"}
          d="M33,34c0-0.205,0.012-0.376,0.018-0.565C33.008,33.184,33,33,33,33s0.012-0.009,0.032-0.022c0.149-2.673,0.886-3.703,1.675-4.29c-0.11-0.153-0.237-0.318-0.356-0.475c-0.333-0.437-0.748-0.979-1.192-1.674l-0.082-0.158c-0.067-0.164-0.229-0.447-0.435-0.819c-1.183-2.14-3.645-6.592-1.96-9.404c0.738-1.232,2.122-1.942,4.121-2.117C33.986,11.718,30.925,6.115,23.985,6c-0.002,0-0.004,0-0.006,0c-6.041-0.098-8.026,5.392-8.672,8.672c0.89-0.377,1.906-0.606,2.836-0.606c0.014,0,0.029,0,0.043,0c2.29,0.017,3.865,1.239,4.323,3.354c0.335,1.552,0.496,2.91,0.492,4.153c-0.01,2.719-0.558,4.149-1.042,5.411l-0.154,0.408c-0.124,0.334-0.255,0.645-0.379,0.937c-0.126,0.298-0.237,0.563-0.318,0.802c0.484,0.11,0.864,0.265,1.125,0.38l0.151,0.066c0.047,0.02,0.094,0.043,0.137,0.069c0.848,0.516,1.376,1.309,1.489,2.233c0.061,0.498,0.051,3.893,0.03,6.855c0.087,1.285,0.305,2.364,0.593,3.146c0.409,1.114,1.431,3.241,3.394,3.119c1.37-0.085,2.687-0.919,3.561-2.019c0.938-1.181,1.284-2.487,1.414-3.958V34z"
        />
        <path
          fill={isActive ? "#0277bd" : "#A9A9A9"}
          d="M15.114 28.917c-1.613-1.683-2.399-3.947-2.104-6.056.285-2.035.124-4.027.037-5.098-.029-.357-.048-.623-.047-.77 0-.008.002-.015.003-.023 0-.004-.002-.007-.002-.011.121-3.021 1.286-7.787 4.493-10.62C15.932 5.724 13.388 4.913 11 5 7.258 5.136 3.636 7.724 4 15c.137 2.73 3.222 19.103 7.44 19 .603-.015 1.229-.402 1.872-1.176 1.017-1.223 2.005-2.332 2.708-3.104C15.705 29.481 15.401 29.217 15.114 28.917zM37.023 14.731c.015.154.002.286-.022.408.031.92-.068 1.813-.169 2.677-.074.636-.15 1.293-.171 1.952-.021.645.07 1.282.166 1.956.225 1.578.459 3.359-.765 5.437.225.296.423.571.581.837 4.61-7.475 6.468-16.361 4.695-18.626C38.655 5.944 34.941 4.952 31.999 5c-.921.015-1.758.139-2.473.294C34.602 7.754 36.863 13.026 37.023 14.731zM41 30.071c-2.665.55-3.947.257-4.569-.126-.1.072-.2.133-.293.19-.372.225-.961.583-1.105 2.782.083.016.156.025.246.044L35.714 33c1.32.06 3.049-.31 4.063-.781C41.962 31.205 43.153 29.627 41 30.071zM22.023 32.119c-.037-.298-.198-.539-.492-.732l-.108-.047C21.062 31.181 20.653 31 20 31h-.004c-.127.01-.253.019-.38.019-.052 0-.103-.007-.155-.009-.474.365-1.148.647-2.816.99-2.98.759-1.221 1.655-.078 1.794 1.106.277 3.735.614 5.481-.809C22.043 32.537 22.035 32.229 22.023 32.119z"
        />
        <path
          fill={isActive ? "#0277bd" : "#A9A9A9"}
          d="M20.681 18.501c-.292.302-.753.566-1.262.484-.828-.134-1.463-1.133-1.417-1.508h0c.044-.374.751-.569 1.578-.435.287.047.548.128.768.228-.32-.688-.899-1.085-1.782-1.182-1.565-.174-3.226.644-3.56 1.097.007.11.02.251.033.417.093 1.147.265 3.284-.05 5.537-.208 1.485.393 3.169 1.567 4.395.757.79 1.641 1.29 2.513 1.438.111-.478.309-.944.513-1.425.113-.265.233-.547.346-.852l.162-.427c.443-1.155.9-2.35.909-4.703C21.003 20.66 20.892 19.627 20.681 18.501zM34.847 22.007c-.104-.729-.211-1.484-.185-2.303.023-.742.105-1.442.184-2.119.062-.533.11-1.045.138-1.55-1.289.107-2.145.479-2.551 1.108.168-.057.358-.102.568-.129.892-.116 1.543.141 1.618.637.055.363-.253.705-.388.836-.277.269-.626.442-.981.488-.064.008-.129.012-.192.012-.353 0-.69-.121-.949-.3.112 1.973 1.567 4.612 2.283 5.907.153.277.271.498.369.688C35.154 24.163 35.009 23.143 34.847 22.007z"
        />
      </svg>
    ),
  },
  {
    name: "Redis",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 -18 256 256"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M245.97 168.943c-13.662 7.121-84.434 36.22-99.501 44.075-15.067 7.856-23.437 7.78-35.34 2.09-11.902-5.69-87.216-36.112-100.783-42.597C3.566 169.271 0 166.535 0 163.951v-25.876s98.05-21.345 113.879-27.024c15.828-5.679 21.32-5.884 34.79-.95 13.472 4.936 94.018 19.468 107.331 24.344l-.006 25.51c.002 2.558-3.07 5.364-10.024 8.988"
          fill={isActive ? "#FF0000" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M245.965 143.22c-13.661 7.118-84.431 36.218-99.498 44.072-15.066 7.857-23.436 7.78-35.338 2.09-11.903-5.686-87.214-36.113-100.78-42.594-13.566-6.485-13.85-10.948-.524-16.166 13.326-5.22 88.224-34.605 104.055-40.284 15.828-5.677 21.319-5.884 34.789-.948 13.471 4.934 83.819 32.935 97.13 37.81 13.316 4.881 13.827 8.9.166 16.02"
          fill={isActive ? "#FF4A4A" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M245.97 127.074c-13.662 7.122-84.434 36.22-99.501 44.078-15.067 7.853-23.437 7.777-35.34 2.087-11.903-5.687-87.216-36.112-100.783-42.597C3.566 127.402 0 124.67 0 122.085V96.206s98.05-21.344 113.879-27.023c15.828-5.679 21.32-5.885 34.79-.95C162.142 73.168 242.688 87.697 256 92.574l-.006 25.513c.002 2.557-3.07 5.363-10.024 8.987"
          fill={isActive ? "#FF0000" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M245.965 101.351c-13.661 7.12-84.431 36.218-99.498 44.075-15.066 7.854-23.436 7.777-35.338 2.087-11.903-5.686-87.214-36.112-100.78-42.594-13.566-6.483-13.85-10.947-.524-16.167C23.151 83.535 98.05 54.148 113.88 48.47c15.828-5.678 21.319-5.884 34.789-.949 13.471 4.934 83.819 32.933 97.13 37.81 13.316 4.88 13.827 8.9.166 16.02"
          fill={isActive ? "#FF4A4A" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M245.97 83.653c-13.662 7.12-84.434 36.22-99.501 44.078-15.067 7.854-23.437 7.777-35.34 2.087-11.903-5.687-87.216-36.113-100.783-42.595C3.566 83.98 0 81.247 0 78.665v-25.88s98.05-21.343 113.879-27.021c15.828-5.68 21.32-5.884 34.79-.95C162.142 29.749 242.688 44.278 256 49.155l-.006 25.512c.002 2.555-3.07 5.361-10.024 8.986"
          fill={isActive ? "#FF0000" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M245.965 57.93c-13.661 7.12-84.431 36.22-99.498 44.074-15.066 7.854-23.436 7.777-35.338 2.09C99.227 98.404 23.915 67.98 10.35 61.497-3.217 55.015-3.5 50.55 9.825 45.331 23.151 40.113 98.05 10.73 113.88 5.05c15.828-5.679 21.319-5.883 34.789-.948 13.471 4.935 83.819 32.934 97.13 37.811 13.316 4.876 13.827 8.897.166 16.017"
          fill={isActive ? "#FF4A4A" : "#A9A9A9"} // Active color logic
        />
        <path
          d="M159.283 32.757l-22.01 2.285-4.927 11.856-7.958-13.23-25.415-2.284 18.964-6.839-5.69-10.498 17.755 6.944 16.738-5.48-4.524 10.855 17.067 6.391"
          fill={isActive ? "#FFF" : "#FFF"} // Active color logic (if needed)
        />
        <path
          d="M185.295 35.998l34.836 13.766-34.806 13.753-.03-27.52"
          fill={isActive ? "#FFAAAA" : "#fff"}
        />
        <path
          d="M146.755 51.243l38.54-15.245.03 27.519-3.779 1.478-34.791-13.752"
          fill={isActive ? "#FFAAAA" : "#fff"}
        />
      </svg>
    ),
    originalFill: "#D82C20",
  },
  {
    name: "TensorFlow",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="-9 0 274 274"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M145.726081,42.0651946 L145.726081,84.1347419 L218.586952,126.204312 L218.586952,84.1347419 L145.726081,42.0651946 Z M-1.98726454e-07,84.1347419 L-1.98726454e-07,126.204312 L36.4304238,147.234755 L36.4304238,105.169527 L-1.98726454e-07,84.1347419 Z M109.291294,105.169527 L72.8608701,126.204312 L72.8608701,252.404316 L109.291294,273.439101 L109.291294,189.304303 L145.726081,210.339088 L145.726081,168.26954 L109.291294,147.234755 L109.291294,105.169527 Z"
            fill={isActive ? "#E55B2D" : "#A9A9A9"}
          ></path>
          <path
            d="M145.726081,42.0651946 L36.4304238,105.169527 L36.4304238,147.234755 L109.291294,105.169527 L109.291294,147.234755 L145.726081,126.204312 L145.726081,42.0651946 Z M255.021717,63.0999794 L218.586952,84.1347419 L218.586952,126.204312 L255.021717,105.169527 L255.021717,63.0999794 Z M182.156505,147.234755 L145.726081,168.26954 L145.726081,210.339088 L182.156505,189.304303 L182.156505,147.234755 Z M145.726081,210.339088 L109.291294,189.304303 L109.291294,273.439101 L145.726081,252.404316 L145.726081,210.339088 Z"
            fill={isActive ? "#ED8E24" : "#A9A9A9"}
          ></path>
          <path
            d="M145.726081,-3.41864288e-05 L-1.98726454e-07,84.1347419 L36.4304238,105.169527 L145.726081,42.0651946 L218.586952,84.1347419 L255.021717,63.0999794 L145.726081,-3.41864288e-05 Z M145.726081,126.204312 L109.291294,147.234755 L145.726081,168.26954 L182.156505,147.234755 L145.726081,126.204312 Z"
            fill={isActive ? "#F8BF3C" : "#A9A9A9"}
          ></path>
        </g>
      </svg>
    ),
  },
  {
    name: "Swift",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="-252 343.9 106.1 106.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={isActive ? "#F05138" : "#A9A9A9"}
          d="M-145.9 373.3v-3.2c-.1-2.3-.2-4.7-.6-7-.4-2.3-1.1-4.5-2.2-6.6-1.1-2.1-2.4-4-4.1-5.6-1.7-1.7-3.6-3-5.6-4.1-2.1-1.1-4.3-1.8-6.6-2.2-2.3-.4-4.6-.6-7-.6h-53.7c-.6 0-1.2 0-1.7.1-1.7.1-3.5.2-5.2.5-1.7.3-3.4.8-5 1.4-.5.2-1.1.5-1.6.7-1.6.8-3 1.8-4.4 2.9-.4.4-.9.8-1.3 1.2-1.7 1.7-3 3.6-4.1 5.6-1.1 2.1-1.8 4.3-2.2 6.6-.4 2.3-.5 4.6-.6 7v53.7c.1 2.3.2 4.7.6 7 .4 2.3 1.1 4.5 2.2 6.6 1.1 2.1 2.4 4 4.1 5.6 1.7 1.7 3.6 3 5.6 4.1 2.1 1.1 4.3 1.8 6.6 2.2 2.3.4 4.6.6 7 .6h53.7c2.3-.1 4.7-.2 7-.6 2.3-.4 4.5-1.1 6.6-2.2 2.1-1.1 4-2.4 5.6-4.1 1.7-1.7 3-3.6 4.1-5.6 1.1-2.1 1.8-4.3 2.2-6.6.4-2.3.6-4.6.6-7v-3.2V377v-3.7z"
        />
        <path
          fill="#FFF"
          d="M-168 409.4l.3-1.2c4.4-17.5-6.3-38.3-24.5-49.2 8 10.8 11.5 23.9 8.4 35.3-.3 1-.6 2-1 3-.4-.3-.9-.6-1.6-.9 0 0-18.1-11.2-37.7-30.9-.5-.5 10.5 15.7 22.9 28.8-5.9-3.3-22.2-15.2-32.6-24.6 1.3 2.1 2.8 4.2 4.4 6.1 8.6 11 19.9 24.5 33.4 34.9-9.5 5.8-22.9 6.3-36.2 0-3.3-1.5-6.4-3.4-9.3-5.5 5.6 9 14.3 16.8 24.9 21.4 12.6 5.4 25.2 5.1 34.5.1 0 0 .1 0 .1-.1.4-.2.8-.5 1.2-.7 4.5-2.3 13.3-4.6 18.1 4.6 1.4 2.1 3.9-9.9-5.3-21.1z"
        />
      </svg>
    ),
  },
  {
    name: "React Native",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill={isActive ? "#00D8FF" : "#A9A9A9"} fill-rule="evenodd">
          <circle cx="11.996" cy="11.653" r="2.142" />
          <path
            fill-rule="nonzero"
            d="M11.9957722,7.80914159 C14.763782,7.80914159 17.3932297,8.19939152 19.3922491,8.88758063 C21.6123871,9.6518808 22.9666335,10.7818833 22.9666335,11.652558 C22.9666335,12.5799965 21.5040812,13.7840336 19.1293161,14.5708627 C17.2387355,15.1972602 14.7092455,15.538679 11.9957722,15.538679 C9.14520032,15.538679 6.58717845,15.203913 4.71853163,14.565185 C3.54866968,14.1653247 2.58256656,13.6456709 1.92037292,13.0785821 C1.32532838,12.5689984 1.02491103,12.0630628 1.02491103,11.652558 C1.02491103,10.7789546 2.32734001,9.66464781 4.49959681,8.90729393 C6.49945246,8.21010004 9.19325759,7.80914159 11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 M11.9957722,6.78423056 C9.08437994,6.78423056 6.2777499,7.20198239 4.1621939,7.93951199 C1.62214541,8.82509585 0,10.2129394 0,11.652558 C0,13.1394248 1.74140227,14.6307252 4.38703934,15.5350074 C6.37567236,16.2147483 9.04125041,16.56359 11.9957722,16.56359 C14.8115523,16.56359 17.4474553,16.2078081 19.4516644,15.5437626 C22.2020573,14.632477 23.9915445,13.1592927 23.9915445,11.652558 C23.9915445,10.2077356 22.3170688,8.81052922 19.7258695,7.91848823 C17.6128656,7.19105846 14.871718,6.78423056 11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 M8.64782576,9.74318674 C10.0306294,7.34537922 11.6822995,5.26251432 13.2771145,3.87459857 C15.0483324,2.33318986 16.7037652,1.72455661 17.4580053,2.15950561 C18.2614273,2.62281187 18.5738182,4.49132292 18.0690455,6.94154209 C17.6671734,8.89223963 16.6992742,11.2540339 15.3437168,13.6046372 C13.9196524,16.0740185 12.3517605,18.1226845 10.8648902,19.4223695 C9.93407029,20.2360369 9.00127666,20.8133347 8.17921011,21.1036655 C7.44050831,21.3645543 6.85214323,21.3720417 6.49651234,21.1669615 C5.73974814,20.7305244 5.42512511,19.045619 5.85426462,16.7855049 C6.24932455,14.7048419 7.24772098,12.1710157 8.64782671,9.74318508 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 M7.759974,9.23116928 C6.30547459,11.7533204 5.26525979,14.3932772 4.84734364,16.5943171 C4.34554839,19.2370813 4.73740525,21.3355983 5.98449631,22.0548141 C7.2725788,22.7976074 9.43439148,22.0341158 11.5394159,20.1940284 C13.121755,18.8108935 14.7555742,16.6760844 16.2315707,14.1166508 C17.6382359,11.6774242 18.6468519,9.21627599 19.0728759,7.1483441 C19.6574939,4.31054745 19.2752706,2.02434609 17.9700071,1.27164481 C16.7184046,0.549880923 14.6715337,1.30242953 12.6042836,3.1014613 C10.9185312,4.56851694 9.19669947,6.73986025 7.75997496,9.23116762 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 M8.65102932,13.6102163 C7.26423584,11.2147037 6.28457878,8.74353725 5.87862056,6.66870559 C5.42774955,4.36439699 5.72720706,2.6262057 6.48072727,2.18999639 C7.28337846,1.72531755 9.05821175,2.38783711 10.9288592,4.04883669 C12.4181905,5.37119379 13.9809502,7.38921897 15.3404734,9.7376059 C16.7686644,12.2045881 17.7605533,14.5861039 18.1440168,16.5233658 C18.384086,17.7361541 18.4183857,18.8326057 18.2593637,19.6898062 C18.1164684,20.4600771 17.8291151,20.9735449 17.473831,21.1792215 C16.7177635,21.6169189 15.1008664,21.0480332 13.3571194,19.5474962 C11.7518336,18.1661133 10.0552117,16.0356933 8.65102599,13.6102105 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 M7.76403451,14.1237168 C9.2227685,16.6434222 10.9904487,18.863069 12.6886037,20.3243677 C14.727583,22.0789594 16.7414064,22.7874988 17.9873239,22.0662207 C19.2741476,21.3212689 19.6923336,19.0670565 19.1494202,16.3243517 C18.741335,14.2627011 17.7077401,11.7810493 16.2274688,9.22410641 C14.8166895,6.78718171 13.1881856,4.68425955 11.6093526,3.2824351 C9.4428116,1.3587035 7.27122101,0.548080175 5.96723274,1.30299809 C4.71682218,2.02685487 4.34655386,4.17606524 4.87278214,6.8655093 C5.30188762,9.05864543 6.32316039,11.6347867 7.76403118,14.1237111 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168"
          />
        </g>
      </svg>
    ),
  },
  {
    name: "jQuery",
    path: (isActive) => (
      <svg
        width="60"
        height="50"
        viewBox="0 -198 480 480"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill="none" fill-rule="evenodd">
          <path
            fill={isActive ? "#1A1918" : "#71777C"}
            d="M489.718 8.646l21.42.118s-39.824 53.964-43.076 58.362c-1.056 1.424-2.66 2.96-3.474 4.864-2.057 4.786-4.169 15.285-4.169 15.285l-19.599.098s3.05-10.944 2.924-16.773c-.11-5.092-2.71-10.178-4.168-15.285-1.474-5.17-3.475-15.286-3.475-15.286h20.15l2.779 11.117 30.688-42.5"
          />

          <path
            fill={isActive ? "#1A1918" : "#71777C"}
            d="M449.157 20.027c3.953 2.383 6.379 15.529 6.379 15.529s-20.684.305-31.94.305h-9.727l-11.812 51.414h-18.064s11.242-55.874 13.896-66.004c.86-3.28 5.892-2.717 14.389-2.717h13.569c8.762 0 19.003-1.119 23.31 1.473M365.06 45.067s.563-3.3-1.91-7.122c-2.113-3.258-4.064-4.016-9.623-4.19-15.695-.493-15.39 11.138-15.39 11.138l26.923.174zm17.022-13.32c2.3 8.297-2.084 27.792-2.084 27.792s-22.894-.382-35.434 0c-3.899.119-8.566-.424-9.727 1.39-1.633 2.542.597 6.455 2.487 8.108 2.175 1.903 6.412 2.12 7.935 2.313 10.178 1.293 31.48.334 31.48.334l-3.69 16.34s-30.103 1.51-45.16-2.084c-2.973-.708-5.76-2.139-7.643-4.168-.514-.555-.96-1.312-1.446-1.966-.388-.522-1.52-2.237-2.028-3.593-3.439-9.164.403-26.72 4.169-36.128.437-1.09.986-2.473 1.564-3.648.722-1.465 1.333-3.119 1.91-3.995.388-.604.869-.993 1.272-1.563.465-.674 1.006-1.327 1.507-1.91 1.39-1.612 2.967-2.752 4.864-4.168 6.273-4.698 17.626-8.345 31.265-6.949 5.135.528 12.89 2.362 16.675 7.643 1.014 1.41 1.515 4.21 2.084 6.253zM299.229 18.49l17.516-.103s-9.762 46.307-14.737 68.888h-20.15c-14.082 0-26.623 1.744-31.959-8.338-5.176-9.789-.236-25.887 2.084-36.824 1.64-7.74 5.094-23.56 5.094-23.56l18.148-.166s-5.128 24.63-7.262 36.928c-.764 4.405-2.34 8.553-.694 11.81 1.563 3.1 3.752 3.322 10.421 3.475 2.113.05 9.033 0 9.033 0l12.506-52.11M217.244 51.84c1.834-6.516 4.509-13.582 4.169-19.454-.368-6.28-5.634-11.998-9.032-13.2-10.234-3.613-19.815 1.438-23.623 5.558-4.926 5.336-6.594 11.569-8.338 20.15-1.298 6.37-2.362 13.095 0 18.063 4.182 8.783 17.224 6.865 31.266 6.949 2.084-5.586 3.807-11.86 5.558-18.066zm24.318-25.706c2 14.548-5.676 30.606-10.964 44.57 5.392.487 10.117-.075 10.457.327.354.521-3.614 16.668-4.997 16.71-4.279.111-18.459.229-24.372.229-19.295 0-37.345 1.257-46.55-8.337-3.738-3.898-6.323-10.583-6.949-15.286-1.042-7.851.264-16.495 2.085-23.622 1.647-6.435 3.758-12.507 6.948-18.066C175.328 8.507 189.432-1.998 213.075.427c4.586.472 11.172 2.48 15.286 4.863.284.167 1.279.959 1.507 1.098 5.559 3.537 10.624 11.978 11.694 19.746zM156.193 18.574c-1.167 5.315-2.334 11.34-3.564 16.592h-19.454c1.507-5.822 2.661-11.61 4.169-16.675 6.225 0 12.013.083 18.85.083M132.48 40.03h18.76c-2.453 13.576-7.31 35.475-11.117 50.719-2.383 9.54-3.974 16.501-10.422 21.538-.577.452-.91.237-1.39.695-1.188 1.133-6.684 2.447-9.726 2.779-4.947.536-10.54.07-16.62-.055 1.591-5.815 3.391-12.798 4.809-18.01 14.82 1.794 15.195-12.214 18.064-25.706 1.66-7.796 6.691-28.834 7.642-31.96"
          />

          <g fill={isActive ? "#21609B" : "#71777C"}>
            <path d="M88.708 75.464l-.402 1.042c-6.85 13.34-18.989 21.524-36.303 21.885-8.094.167-15.806-1.91-20.844-4.168C20.287 89.338 11.142 80.279 6.148 70.6c-7.164-13.875-8.456-33.176 6.44-47.592.23 0-1.807 3.126-1.577 3.126l-.41 1.334C-.133 61.074 32.938 89.874 65.086 86.58c7.726-.792 17.578-5.023 23.622-11.116" />

            <path d="M69.254 61.568c8.088.055 16.536-3.725 21.539-9.032-4.377 11.11-17.05 18.251-34.044 15.98-14.23-1.904-27.785-16.223-29.181-30.571-1.021-10.442 2.618-16.674 8.615-24.234-2.084 3.954-2.863 7.003-3.057 8.948-2.278 22.588 18.044 38.79 36.128 38.909" />

            <path d="M89.98 33.512c-1.257 2.884-8.496 8.33-11.693 9.011-12.659 2.697-20.766-3.306-25.013-10.137-.631-1.02-1.798-3.806-2.007-4.515-1.647-5.6-.89-14.07 4.023-18.454-1.48 4.169-1.696 9.011-.917 12.159.472 1.903 1.91 5.226 3.349 7.316 2.618 3.807 4.279 4.732 7.642 6.754 1.515.91 3.14 1.64 3.842 1.84 3.189.939 9.922 3.412 20.775-3.974" />
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: "AngularJS",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 2L3 7L5 24L16 30L27 24L29 7L16 2Z"
          fill={isActive ? "#DD0031" : "#A9A9A9"} // Red when active, gray when inactive
        />
        <path
          d="M16 2V30L27 24L29 7L16 2Z"
          fill={isActive ? "#C3002F" : "#A9A9A9"} // Dark red when active, gray when inactive
        />
        <path
          d="M15.9998 5.09375L7.87305 23.3638H10.9031L12.5368 19.2757H19.4348L21.0685 23.3638H24.0986L15.9998 5.09375ZM18.3736 16.7557H13.626L15.9998 11.0298L18.3736 16.7557Z"
          fill="white"
        />
      </svg>
    ),
  },
  {
    name: "React",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g fill={isActive ? "#00D8FF" : "#A9A9A9"} fill-rule="evenodd">
          <circle cx="11.996" cy="11.653" r="2.142" />
          <path
            fill-rule="nonzero"
            d="M11.9957722,7.80914159 C14.763782,7.80914159 17.3932297,8.19939152 19.3922491,8.88758063 C21.6123871,9.6518808 22.9666335,10.7818833 22.9666335,11.652558 C22.9666335,12.5799965 21.5040812,13.7840336 19.1293161,14.5708627 C17.2387355,15.1972602 14.7092455,15.538679 11.9957722,15.538679 C9.14520032,15.538679 6.58717845,15.203913 4.71853163,14.565185 C3.54866968,14.1653247 2.58256656,13.6456709 1.92037292,13.0785821 C1.32532838,12.5689984 1.02491103,12.0630628 1.02491103,11.652558 C1.02491103,10.7789546 2.32734001,9.66464781 4.49959681,8.90729393 C6.49945246,8.21010004 9.19325759,7.80914159 11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 L11.9957722,7.80914159 M11.9957722,6.78423056 C9.08437994,6.78423056 6.2777499,7.20198239 4.1621939,7.93951199 C1.62214541,8.82509585 0,10.2129394 0,11.652558 C0,13.1394248 1.74140227,14.6307252 4.38703934,15.5350074 C6.37567236,16.2147483 9.04125041,16.56359 11.9957722,16.56359 C14.8115523,16.56359 17.4474553,16.2078081 19.4516644,15.5437626 C22.2020573,14.632477 23.9915445,13.1592927 23.9915445,11.652558 C23.9915445,10.2077356 22.3170688,8.81052922 19.7258695,7.91848823 C17.6128656,7.19105846 14.871718,6.78423056 11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 L11.9957722,6.78423056 M8.64782576,9.74318674 C10.0306294,7.34537922 11.6822995,5.26251432 13.2771145,3.87459857 C15.0483324,2.33318986 16.7037652,1.72455661 17.4580053,2.15950561 C18.2614273,2.62281187 18.5738182,4.49132292 18.0690455,6.94154209 C17.6671734,8.89223963 16.6992742,11.2540339 15.3437168,13.6046372 C13.9196524,16.0740185 12.3517605,18.1226845 10.8648902,19.4223695 C9.93407029,20.2360369 9.00127666,20.8133347 8.17921011,21.1036655 C7.44050831,21.3645543 6.85214323,21.3720417 6.49651234,21.1669615 C5.73974814,20.7305244 5.42512511,19.045619 5.85426462,16.7855049 C6.24932455,14.7048419 7.24772098,12.1710157 8.64782671,9.74318508 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 L8.64782576,9.74318674 M7.759974,9.23116928 C6.30547459,11.7533204 5.26525979,14.3932772 4.84734364,16.5943171 C4.34554839,19.2370813 4.73740525,21.3355983 5.98449631,22.0548141 C7.2725788,22.7976074 9.43439148,22.0341158 11.5394159,20.1940284 C13.121755,18.8108935 14.7555742,16.6760844 16.2315707,14.1166508 C17.6382359,11.6774242 18.6468519,9.21627599 19.0728759,7.1483441 C19.6574939,4.31054745 19.2752706,2.02434609 17.9700071,1.27164481 C16.7184046,0.549880923 14.6715337,1.30242953 12.6042836,3.1014613 C10.9185312,4.56851694 9.19669947,6.73986025 7.75997496,9.23116762 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 L7.759974,9.23116928 M8.65102932,13.6102163 C7.26423584,11.2147037 6.28457878,8.74353725 5.87862056,6.66870559 C5.42774955,4.36439699 5.72720706,2.6262057 6.48072727,2.18999639 C7.28337846,1.72531755 9.05821175,2.38783711 10.9288592,4.04883669 C12.4181905,5.37119379 13.9809502,7.38921897 15.3404734,9.7376059 C16.7686644,12.2045881 17.7605533,14.5861039 18.1440168,16.5233658 C18.384086,17.7361541 18.4183857,18.8326057 18.2593637,19.6898062 C18.1164684,20.4600771 17.8291151,20.9735449 17.473831,21.1792215 C16.7177635,21.6169189 15.1008664,21.0480332 13.3571194,19.5474962 C11.7518336,18.1661133 10.0552117,16.0356933 8.65102599,13.6102105 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 L8.65102932,13.6102163 M7.76403451,14.1237168 C9.2227685,16.6434222 10.9904487,18.863069 12.6886037,20.3243677 C14.727583,22.0789594 16.7414064,22.7874988 17.9873239,22.0662207 C19.2741476,21.3212689 19.6923336,19.0670565 19.1494202,16.3243517 C18.741335,14.2627011 17.7077401,11.7810493 16.2274688,9.22410641 C14.8166895,6.78718171 13.1881856,4.68425955 11.6093526,3.2824351 C9.4428116,1.3587035 7.27122101,0.548080175 5.96723274,1.30299809 C4.71682218,2.02685487 4.34655386,4.17606524 4.87278214,6.8655093 C5.30188762,9.05864543 6.32316039,11.6347867 7.76403118,14.1237111 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168 L7.76403451,14.1237168"
          />
        </g>
      </svg>
    ),
  },
  {
    name: "Django",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={isActive ? "#44b78b" : "#A9A9A9"}
          d="M14.135,4H18.1V22.169a26.218,26.218,0,0,1-5.143.535c-4.842-.005-7.362-2.168-7.362-6.322,0-4,2.673-6.6,6.816-6.6a6.448,6.448,0,0,1,1.724.2V4Zm0,9.142a3.992,3.992,0,0,0-1.337-.2c-2,0-3.163,1.223-3.163,3.366,0,2.087,1.107,3.239,3.138,3.239a9.355,9.355,0,0,0,1.362-.1v-6.3Z"
        />
        <path
          fill={isActive ? "#44b78b" : "#A9A9A9"}
          d="M24.4,10.059v9.1c0,3.133-.235,4.639-.923,5.938A6.316,6.316,0,0,1,20.237,28l-3.678-1.733A5.708,5.708,0,0,0,19.7,23.638c.566-1.121.745-2.42.745-5.837V10.059Z"
        />
        <rect
          x="20.441"
          y="4.02"
          width="3.964"
          height="4.028"
          fill={isActive ? "#44b78b" : "#A9A9A9"}
        />
      </svg>
    ),
  },
  {
    name: "Node.js",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 50 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={isActive ? "#539E43" : "#71777C"}
          d="M21.8952 49.4138C21.2382 49.4138 20.5714 49.2375 19.9929 48.904L13.943 45.3252C13.041 44.8152 13.4822 44.6388 13.7764 44.5407C14.9823 44.119 15.2275 44.0309 16.5119 43.2954C16.6493 43.2171 16.8258 43.2463 16.963 43.3347L21.6107 46.0899C21.7774 46.1879 22.0126 46.1879 22.1695 46.0899L40.28 35.6373C40.4468 35.5392 40.5544 35.3432 40.5544 35.1471V14.2422C40.5544 14.0363 40.4468 13.85 40.2703 13.7423L22.1696 3.29946C22.003 3.20139 21.7775 3.20139 21.6108 3.29946L3.52 13.7519C3.3434 13.85 3.23565 14.0461 3.23565 14.252V35.1471C3.23565 35.3432 3.3434 35.5392 3.52 35.6276L8.4816 38.4908C11.1781 39.834 12.8253 38.2554 12.8253 36.6573V16.0267C12.8253 15.7326 13.0606 15.5071 13.3549 15.5071H15.6493C15.9337 15.5071 16.1787 15.7326 16.1787 16.0267V36.6671C16.1787 40.2557 14.2176 42.3149 10.8153 42.3149C9.76605 42.3149 8.94244 42.3149 6.64802 41.1775L1.90223 38.4418C0.725527 37.7651 0 36.5002 0 35.1375V14.2422C0 12.8891 0.725527 11.6145 1.90223 10.9379L19.9929 0.485332C21.1401 -0.161777 22.66 -0.161777 23.7974 0.485332L41.9081 10.9476C43.0847 11.6241 43.8102 12.889 43.8102 14.252V35.1471C43.8102 36.5002 43.0847 37.7651 41.9081 38.4516L23.7974 48.904C23.2188 49.2375 22.5617 49.4138 21.8952 49.4138ZM36.5151 28.813C36.5151 24.9006 33.8675 23.8613 28.308 23.126C22.6796 22.3807 22.111 21.9983 22.111 20.6844C22.111 19.5961 22.5915 18.1448 26.7587 18.1448C30.4751 18.1448 31.8478 18.9489 32.4164 21.4591C32.4655 21.6944 32.6814 21.8709 32.9262 21.8709H35.2798C35.4267 21.8709 35.5639 21.8121 35.6621 21.7042C35.7603 21.5964 35.8092 21.4492 35.7991 21.3021C35.4365 16.9781 32.5634 14.968 26.7587 14.968C21.5914 14.968 18.5126 17.1447 18.5126 20.8021C18.5126 24.7634 21.5815 25.8618 26.5331 26.3518C32.4655 26.9305 32.9262 27.8031 32.9262 28.97C32.9262 30.99 31.2988 31.8526 27.4844 31.8526C22.6896 31.8526 21.6404 30.6466 21.2874 28.2641C21.2482 28.0092 21.0323 27.8229 20.7678 27.8229H18.4241C18.13 27.8229 17.9046 28.0583 17.9046 28.3424C17.9046 31.3921 19.5617 35.0298 27.4943 35.0298C33.2204 35.02 36.5151 32.7545 36.5151 28.813Z"
        />
      </svg>
    ),
    originalFill: "#539E43",
  },
  {
    name: "Python",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={`M13.0164 2C10.8193 2 9.03825 3.72453 9.03825 5.85185V8.51852H15.9235V9.25926H5.97814C3.78107 9.25926 2 10.9838 2 13.1111L2 18.8889C2 21.0162 3.78107 22.7407 5.97814 22.7407H8.27322V19.4815C8.27322 17.3542 10.0543 15.6296 12.2514 15.6296H19.5956C21.4547 15.6296 22.9617 14.1704 22.9617 12.3704V5.85185C22.9617 3.72453 21.1807 2 18.9836 2H13.0164ZM12.0984 6.74074C12.8589 6.74074 13.4754 6.14378 13.4754 5.40741C13.4754 4.67103 12.8589 4.07407 12.0984 4.07407C11.3378 4.07407 10.7213 4.67103 10.7213 5.40741C10.7213 6.14378 11.3378 6.74074 12.0984 6.74074Z`}
          fill={
            isActive
              ? "url(#paint0_linear_active)"
              : "url(#paint0_linear_inactive)"
          }
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={`M18.9834 30C21.1805 30 22.9616 28.2755 22.9616 26.1482V23.4815L16.0763 23.4815L16.0763 22.7408L26.0217 22.7408C28.2188 22.7408 29.9998 21.0162 29.9998 18.8889V13.1111C29.9998 10.9838 28.2188 9.25928 26.0217 9.25928L23.7266 9.25928V12.5185C23.7266 14.6459 21.9455 16.3704 19.7485 16.3704L12.4042 16.3704C10.5451 16.3704 9.03809 17.8296 9.03809 19.6296L9.03809 26.1482C9.03809 28.2755 10.8192 30 13.0162 30H18.9834ZM19.9015 25.2593C19.1409 25.2593 18.5244 25.8562 18.5244 26.5926C18.5244 27.329 19.1409 27.9259 19.9015 27.9259C20.662 27.9259 21.2785 27.329 21.2785 26.5926C21.2785 25.8562 20.662 25.2593 19.9015 25.2593Z`}
          fill={
            isActive
              ? "url(#paint1_linear_active)"
              : "url(#paint1_linear_inactive)"
          }
        />
        <defs>
          <linearGradient
            id="paint0_linear_active"
            x1="12.4809"
            y1="2"
            x2="12.4809"
            y2="22.7407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#327EBD" />
            <stop offset="1" stopColor="#1565A7" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_active"
            x1="19.519"
            y1="9.25928"
            x2="19.519"
            y2="30"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FFDA4B" />
            <stop offset="1" stopColor="#F9C600" />
          </linearGradient>
          <linearGradient
            id="paint0_linear_inactive"
            x1="12.4809"
            y1="2"
            x2="12.4809"
            y2="22.7407"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#A9A9A9" />
            <stop offset="1" stopColor="#808080" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_inactive"
            x1="19.519"
            y1="9.25928"
            x2="19.519"
            y2="30"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D3D3D3" />
            <stop offset="1" stopColor="#A9A9A9" />
          </linearGradient>
        </defs>
      </svg>
    ),
  },
  {
    name: "Spring",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 256 256"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            fill={isActive ? "#6DB33F" : "#A9A9A9"}
            d="M38.9437824,35.879008 C89.5234256,-13.1200214 170.398168,-11.8028432 219.397197,39.0402357 C224.929346,31.6640377 229.671187,23.4975328 233.095851,15.0675923 C249.165425,64.0666217 258.912543,105.162582 255.224444,137.038295 C253.380395,163.90873 242.842969,189.725423 225.456217,210.273403 C180.145286,264.014274 99.53398,270.863601 45.7931091,225.55267 L45.7931091,225.55267 L44.765,224.638 L44.7103323,224.601984 C44.5420247,224.484832 44.376007,224.362668 44.2124952,224.235492 C43.7219599,223.853965 43.2765312,223.438607 42.8762093,222.995252 L42.732,222.831 L41.0512675,221.3377 C39.4121124,219.93271 37.7729573,218.52772 36.3188215,216.93771 L35.7825547,216.332423 C-13.2164747,165.752779 -11.6358609,84.8780374 38.9437824,35.879008 Z M57.9111486,207.375611 C53.169307,203.687512 46.3199803,204.214383 42.6318814,208.956225 C39.3888978,213.125775 39.4048731,218.924805 42.6798072,222.771269 L42.732,222.831 L44.765,224.638 L44.9644841,224.773953 C49.5691585,227.80174 55.7644273,227.175885 59.2982065,222.896387 L59.4917624,222.654878 C63.1798614,217.913037 62.3895545,211.06371 57.9111486,207.375611 Z M231.778672,28.2393744 C218.60689,55.9001168 185.940871,76.9749681 157.753257,83.5608592 C131.146257,89.8833146 107.963921,84.6146018 83.4644059,94.0982849 C27.6160498,115.436572 28.6697923,181.822354 59.2283268,196.838185 L59.2283268,196.838185 L61.0723763,197.891928 C61.0723763,197.891928 83.1456487,193.50309 104.973663,187.707242 L106.843514,187.207079 C115.561826,184.857554 124.138869,182.296538 131.146257,179.714869 C167.500376,166.279651 207.542593,133.08676 220.714375,94.6251562 C213.865049,134.667374 179.35498,173.392413 144.84491,191.042601 C126.404416,200.526284 112.178891,202.633769 81.883792,213.171195 C78.195693,214.488373 75.297901,215.805551 75.297901,215.805551 C75.6675607,215.754564 76.0372203,215.70481 76.4060145,215.65629 L77.1421925,215.560893 L77.1421925,215.560893 L77.8745239,215.468787 C84.5652297,214.639554 90.5771682,214.224938 90.5771682,214.224938 C133.517178,212.117452 200.956702,226.342977 232.305544,184.45671 C264.444692,141.780136 246.531068,72.7599979 231.778672,28.2393744 Z"
          ></path>
          <path
            fill={isActive ? "#FFFFFF" : "#FFFFFF"}
            d="M57.9111486,207.375611 C62.3895545,211.06371 63.1798614,217.913037 59.4917624,222.654878 C55.8036635,227.39672 48.9543368,227.923591 44.2124952,224.235492 C39.4706537,220.547393 38.9437824,213.698066 42.6318814,208.956225 C46.3199803,204.214383 53.169307,203.687512 57.9111486,207.375611 Z M231.778672,28.2393744 C246.531068,72.7599979 264.444692,141.780136 232.305544,184.45671 C200.956702,226.342977 133.517178,212.117452 90.5771682,214.224938 C90.5771682,214.224938 84.5652297,214.639554 77.8745239,215.468787 L77.1421925,215.560893 C76.5300999,215.63902 75.9140004,215.720572 75.297901,215.805551 C75.297901,215.805551 78.195693,214.488373 81.883792,213.171195 C112.178891,202.633769 126.404416,200.526284 144.84491,191.042601 C179.35498,173.392413 213.865049,134.667374 220.714375,94.6251562 C207.542593,133.08676 167.500376,166.279651 131.146257,179.714869 C106.119871,188.935116 61.0723763,197.891928 61.0723763,197.891928 L59.2283268,196.838185 C28.6697923,181.822354 27.6160498,115.436572 83.4644059,94.0982849 C107.963921,84.6146018 131.146257,89.8833146 157.753257,83.5608592 C185.940871,76.9749681 218.60689,55.9001168 231.778672,28.2393744 Z"
          ></path>
        </g>
      </svg>
    ),
  },
  {
    name: "Kubernetes",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          fill={isActive ? "#326DE6" : "#A9A9A9"}
          d="M4.5 14.569c.214.278.539.431.874.431h5.251c.335 0 .66-.165.875-.434l3.258-4.178c.214-.278.288-.633.214-.978l-1.165-5.207a1.128 1.128 0 00-.606-.777l-4.714-2.31A1.062 1.062 0 008.002 1c-.168 0-.335.038-.485.115l-4.715 2.32a1.129 1.129 0 00-.605.777L1.032 9.42c-.084.345 0 .7.214.978L4.5 14.568z"
        />
        <path
          fill="#ffffff"
          fill-rule="evenodd"
          d="M12.741 9.128c.098.002.196.01.293.024l.058.013.031.008a.308.308 0 01.26.371.306.306 0 01-.396.223h-.004l-.003-.001-.003-.002a1.58 1.58 0 00-.03-.006l-.05-.01a2.55 2.55 0 01-.274-.106 2.867 2.867 0 00-.533-.157.242.242 0 00-.171.064 4.656 4.656 0 00-.131-.023 3.971 3.971 0 01-1.764 2.212c.015.042.032.083.051.123a.239.239 0 00-.023.18c.074.17.165.332.271.484.06.078.114.16.164.244l.028.057.012.025a.306.306 0 01-.381.44.308.308 0 01-.172-.18l-.01-.02a1.57 1.57 0 01-.028-.058 2.546 2.546 0 01-.089-.28 2.837 2.837 0 00-.21-.512.242.242 0 00-.156-.095l-.03-.053-.035-.064a3.97 3.97 0 01-2.823-.007l-.07.125a.25.25 0 00-.132.064 2.13 2.13 0 00-.237.548 2.518 2.518 0 01-.088.28 1.196 1.196 0 01-.025.05l-.013.027v.001a.306.306 0 01-.421.173.308.308 0 01-.173-.314.306.306 0 01.041-.12l.014-.03.026-.052c.05-.085.104-.166.164-.244.108-.156.2-.322.277-.496a.302.302 0 00-.028-.173l.056-.133A3.972 3.972 0 014.22 9.532l-.134.023a.34.34 0 00-.176-.062 2.871 2.871 0 00-.533.156c-.09.04-.181.075-.274.105a1.017 1.017 0 01-.05.011l-.03.007H3.02l-.002.002h-.005a.308.308 0 01-.397-.349.306.306 0 01.261-.245l.005-.001h.002l.006-.002c.024-.006.054-.014.076-.018.097-.013.195-.021.293-.023.186-.013.37-.043.549-.09a.422.422 0 00.131-.133l.128-.037a3.938 3.938 0 01.625-2.752l-.098-.087a.338.338 0 00-.062-.176 2.854 2.854 0 00-.455-.319 2.557 2.557 0 01-.254-.148l-.048-.038-.015-.013-.004-.003a.323.323 0 01-.076-.45.295.295 0 01.244-.107.365.365 0 01.213.08l.022.017c.016.013.034.026.046.037.072.067.139.139.202.213.125.137.263.262.412.372.056.03.121.036.182.018l.11.078a3.938 3.938 0 012.552-1.224l.008-.129a.332.332 0 00.099-.158 2.844 2.844 0 00-.034-.553 2.56 2.56 0 01-.042-.29v-.082-.005A.306.306 0 018 2.82a.308.308 0 01.306.337v.087a2.529 2.529 0 01-.041.29 2.85 2.85 0 00-.035.553.242.242 0 00.1.153v.007l.007.129c.967.088 1.87.522 2.54 1.223l.116-.082a.34.34 0 00.186-.02c.149-.11.287-.236.412-.373.063-.075.13-.146.202-.213l.051-.04.017-.014a.307.307 0 11.381.477l-.024.02c-.015.012-.03.025-.043.034a2.537 2.537 0 01-.254.148 2.87 2.87 0 00-.455.32.241.241 0 00-.058.172l-.05.044-.058.053c.542.806.77 1.783.637 2.745l.123.036c.031.055.077.101.133.132.179.048.363.078.548.09zM7.291 5.24c.107-.024.216-.043.326-.056l-.09 1.6-.008.004a.268.268 0 01-.293.256.27.27 0 01-.135-.05l-.002.001-1.316-.93c.419-.41.945-.696 1.518-.825zm1.618 1.75l1.308-.924a3.182 3.182 0 00-1.833-.882l.09 1.598h.002a.268.268 0 00.294.256.27.27 0 00.135-.05l.004.002zm2.248 1.656L9.609 8.2l-.002-.006a.27.27 0 01-.185-.343.27.27 0 01.08-.12L9.5 7.73l1.195-1.067c.366.594.527 1.29.46 1.983zM9.096 9.5l.618 1.49a3.148 3.148 0 001.275-1.598l-1.593-.269-.002.003a.26.26 0 00-.166.023.27.27 0 00-.13.348l-.002.003zm-.385 1.905c-.573.13-1.17.1-1.727-.088l.777-1.4h.001a.27.27 0 01.475-.001h.006l.779 1.402a3.286 3.286 0 01-.311.087zm-2.418-.422l.611-1.474-.004-.006a.268.268 0 00-.297-.37L6.6 9.13l-1.579.267a3.16 3.16 0 001.272 1.586zm-.997-4.32l1.201 1.071-.001.007a.269.269 0 01-.106.462l-.001.005-1.54.443a3.134 3.134 0 01.447-1.988zm2.95 1.154h-.492l-.307.38.11.476.443.213.442-.212.11-.476-.306-.381z"
          clip-rule="evenodd"
        />
      </svg>
    ),
  },
  {
    name: "Ansible",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="-29.5 0 315 315"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <g>
          <g
            transform="translate(0.000000, 281.859985)"
            fill={isActive ? "#1A1918" : "#A9A9A9"}
          >
            <path d="M67.516834,32.0035248 C66.9753105,32.0035248 66.3906671,31.8666739 65.9847187,31.3176926 L48.6011921,8.45648614 L48.6011921,31.775177 L44.6368825,31.775177 L44.6368825,3.06093065 C44.6368825,1.91840275 45.5828006,1.00382829 46.6646822,1.00382829 C47.2943879,1.00382829 47.8355229,1.18642767 48.239529,1.73540898 L65.5791587,24.5512613 L65.5791587,1.323673 L69.5430798,1.323673 L69.5430798,29.9917765 C69.5430798,31.1808416 68.5971618,32.0035248 67.516834,32.0035248"></path>
            <path d="M100.306277,32.277976 C96.3435217,32.277976 92.1993517,31.4545041 88.3259436,29.9921314 L89.2722501,26.6994268 C92.8302228,27.8427434 96.7032425,28.665821 100.306277,28.665821 C105.305853,28.665821 107.917907,26.8824205 107.917907,24.3682281 C107.917907,22.0815948 105.890496,20.9386725 98.9097372,17.6463622 C91.9289785,14.3544463 89.1825141,12.2515955 89.1825141,8.13581322 C89.1825141,2.9701831 93.1452698,0.865754758 100.620936,0.865754758 C103.729063,0.865754758 108.502551,1.50662733 111.250957,2.32970491 L110.620086,5.71272332 C107.601695,4.98153702 103.819576,4.47869854 100.711449,4.47869854 C95.4430543,4.47869854 93.2808449,5.48398111 93.2808449,7.99935666 C93.2808449,10.4678006 94.8564686,11.5196204 102.242787,14.949176 C110.034666,18.561331 112.016238,20.39048 112.016238,24.1390915 C112.016238,29.5807898 106.881088,32.277976 100.306277,32.277976"></path>
            <path d="M130.798131,1.323673 L134.896461,1.323673 L134.896461,31.7747826 L130.798131,31.7747826 L130.798131,1.323673 Z"></path>
            <path d="M169.757834,17.9669168 L159.578047,17.9669168 L159.578047,28.3009377 L169.757834,28.3009377 C173.225294,28.3009377 175.342053,26.1058013 175.342053,23.0418388 C175.342053,20.1612645 173.135558,17.9669168 169.757834,17.9669168 M167.775097,4.79846437 L159.578047,4.79846437 L159.578047,14.5377556 L167.775097,14.5377556 C171.063473,14.5377556 173.450217,12.434116 173.450217,9.50818761 C173.450217,6.62761329 171.378132,4.79846437 167.775097,4.79846437 M169.802508,31.7750587 L157.552578,31.7750587 C156.38096,31.7750587 155.480104,30.8600898 155.480104,29.7175619 L155.480104,3.38144581 C155.480104,2.2834832 156.38096,1.32394907 157.552578,1.32394907 L167.685749,1.32394907 C173.900839,1.32394907 177.59361,4.38712277 177.59361,9.1883429 C177.59361,11.7940322 176.062271,14.2175165 173.719813,15.6349294 C177.189215,16.6867492 179.529731,19.5669291 179.529731,23.0418388 C179.529731,27.888413 175.522302,31.7750587 169.802508,31.7750587"></path>
            <path d="M199.212246,31.7750981 C198.088022,31.7750981 197.186778,30.8147752 197.186778,29.7176013 L197.186778,1.32398851 L201.284331,1.32398851 L201.284331,28.0718406 L217.588307,28.0718406 L217.588307,31.7750981 L199.212246,31.7750981 Z"></path>
            <path d="M245.526181,32.277976 C237.148883,32.277976 232.104634,29.1690539 232.104634,22.9050667 C232.104634,19.9329955 233.771547,17.0981697 237.014473,15.7722536 C234.40203,14.1260985 233.051329,11.7941111 233.051329,9.23377583 C233.051329,3.56451846 237.421198,0.865754758 245.617083,0.865754758 C248.364713,0.865754758 252.237344,1.18638824 255.480658,1.91836331 L255.029647,5.30138173 C251.607638,4.75240042 248.408609,4.43334448 245.301259,4.43334448 C239.986637,4.43334448 237.148883,5.89571709 237.148883,9.4167696 C237.148883,12.2062414 239.761714,14.4005891 243.230339,14.4005891 L250.255383,14.4005891 C251.246364,14.4005891 252.011644,15.1779182 252.011644,16.1378468 C252.011644,17.1435237 251.246364,17.9208529 250.255383,17.9208529 L242.69037,17.9208529 C238.725672,17.9208529 236.204907,19.8864583 236.204907,22.9050667 C236.204907,27.3399049 240.303238,28.665821 245.437222,28.665821 C248.229914,28.665821 252.011644,28.3010166 255.073933,27.5690415 L255.660907,30.9063115 C252.73264,31.7297835 248.903905,32.277976 245.526181,32.277976"></path>
            <path d="M14.1379982,7.03469555 L21.3157099,25.0189603 L10.4751393,16.3496305 L14.1379982,7.03469555 Z M26.8894398,29.1623494 L15.8495854,2.18772698 C15.5345384,1.41039785 14.9036674,0.99866187 14.1379982,0.99866187 C13.372329,0.99866187 12.6967842,1.41039785 12.3817372,2.18772698 L0.263885888,31.7751375 L4.40844431,31.7751375 L9.20601639,19.5768676 L23.5202622,31.3176531 C24.0959709,31.7897297 24.5112425,32.0034854 25.0523775,32.0034854 C26.1327053,32.0034854 27.0786234,31.1808022 27.0786234,29.9921314 C27.0786234,29.7992781 27.0106416,29.492448 26.8894398,29.1623494 L26.8894398,29.1623494 Z"></path>
          </g>
          <g>
            <path
              fill={isActive ? "#1A1918" : "#A9A9A9"}
              d="M255.878566,127.868028 C255.878566,198.323171 198.768494,255.43274 128.312347,255.43274 C57.8622265,255.43274 0.746127325,198.323171 0.746127325,127.868028 C0.746127325,57.4179077 57.8622265,0.301808544 128.312347,0.301808544 C198.768494,0.301808544 255.878566,57.4179077 255.878566,127.868028"
            ></path>
            <path
              d="M130.459863,78.228885 L163.47146,159.705138 L113.608007,120.427335 L130.459863,78.228885 Z M189.104342,178.474123 L138.32577,56.2720498 C136.876246,52.7476854 133.977698,50.8827909 130.459863,50.8827909 C126.935499,50.8827909 123.826002,52.7476854 122.376477,56.2720498 L66.6436045,190.312411 L85.708924,190.312411 L107.771234,135.047143 L173.610097,188.23707 C176.258016,190.378208 178.168617,191.346566 180.652297,191.346566 C185.626186,191.346566 189.973756,187.617782 189.973756,182.235555 C189.973756,181.359612 189.664363,179.969354 189.104342,178.474123 L189.104342,178.474123 Z"
              fill="#FFFFFF"
            ></path>
          </g>
        </g>
      </svg>
    ),
  },
  {
    name: "Docker",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <circle
          cx="16"
          cy="16"
          r="14"
          fill={isActive ? "#1794D4" : "#A9A9A9"}
        />
        <path d="M18 7H16V9H18V7Z" fill="white" />
        <path d="M10 10H12V12H10V10Z" fill="white" />
        <path
          d="M6.00155 16.9414C6.17244 19.8427 7.90027 24 14 24C20.8 24 23.8333 19 24.5 16.5C25.3333 16.5 27.2 16 28 14C27.5 13.5 25.5 13.5 24.5 14C24.5 13.2 24 11.5 23 11C22.3333 11.6667 21.3 13.4 22.5 15C22 16 20.6667 16 20 16H6.9429C6.41342 16 5.97041 16.4128 6.00155 16.9414Z"
          fill="white"
        />
        <path d="M9 13H7V15H9V13Z" fill="white" />
        <path d="M10 13H12V15H10V13Z" fill="white" />
        <path d="M15 13H13V15H15V13Z" fill="white" />
        <path d="M16 13H18V15H16V13Z" fill="white" />
        <path d="M21 13H19V15H21V13Z" fill="white" />
        <path d="M15 10H13V12H15V10Z" fill="white" />
        <path d="M16 10H18V12H16V10Z" fill="white" />
      </svg>
    ),
  },
  {
    name: "AWS",
    path: (isActive) => (
      <svg
        width="45"
        height="50"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          fill={isActive ? "#252F3E" : "#A9A9A9"}
          d="M4.51 7.687c0 .197.02.357.058.475.042.117.096.245.17.384a.233.233 0 01.037.123c0 .053-.032.107-.1.16l-.336.224a.255.255 0 01-.138.048c-.054 0-.107-.026-.16-.074a1.652 1.652 0 01-.192-.251 4.137 4.137 0 01-.165-.315c-.415.491-.936.737-1.564.737-.447 0-.804-.129-1.064-.385-.261-.256-.394-.598-.394-1.025 0-.454.16-.822.484-1.1.325-.278.756-.416 1.304-.416.18 0 .367.016.564.042.197.027.4.07.612.118v-.39c0-.406-.085-.689-.25-.854-.17-.166-.458-.246-.868-.246-.186 0-.377.022-.574.07a4.23 4.23 0 00-.575.181 1.525 1.525 0 01-.186.07.326.326 0 01-.085.016c-.075 0-.112-.054-.112-.166v-.262c0-.085.01-.15.037-.186a.399.399 0 01.15-.113c.185-.096.409-.176.67-.24.26-.07.537-.101.83-.101.633 0 1.096.144 1.394.432.293.288.442.726.442 1.314v1.73h.01zm-2.161.811c.175 0 .356-.032.548-.096.191-.064.362-.182.505-.342a.848.848 0 00.181-.341c.032-.129.054-.283.054-.465V7.03a4.43 4.43 0 00-.49-.09 3.996 3.996 0 00-.5-.033c-.357 0-.618.07-.793.214-.176.144-.26.347-.26.614 0 .25.063.437.196.566.128.133.314.197.559.197zm4.273.577c-.096 0-.16-.016-.202-.054-.043-.032-.08-.106-.112-.208l-1.25-4.127a.938.938 0 01-.049-.214c0-.085.043-.133.128-.133h.522c.1 0 .17.016.207.053.043.032.075.107.107.208l.894 3.535.83-3.535c.026-.106.058-.176.1-.208a.365.365 0 01.214-.053h.425c.102 0 .17.016.213.053.043.032.08.107.101.208l.841 3.578.92-3.578a.458.458 0 01.107-.208.346.346 0 01.208-.053h.495c.085 0 .133.043.133.133 0 .027-.006.054-.01.086a.76.76 0 01-.038.133l-1.283 4.127c-.032.107-.069.177-.111.209a.34.34 0 01-.203.053h-.457c-.101 0-.17-.016-.213-.053-.043-.038-.08-.107-.101-.214L8.213 5.37l-.82 3.439c-.026.107-.058.176-.1.213-.043.038-.118.054-.213.054h-.458zm6.838.144a3.51 3.51 0 01-.82-.096c-.266-.064-.473-.134-.612-.214-.085-.048-.143-.101-.165-.15a.378.378 0 01-.031-.149v-.272c0-.112.042-.166.122-.166a.3.3 0 01.096.016c.032.011.08.032.133.054.18.08.378.144.585.187.213.042.42.064.633.064.336 0 .596-.059.777-.176a.575.575 0 00.277-.508.52.52 0 00-.144-.373c-.095-.102-.276-.193-.537-.278l-.772-.24c-.388-.123-.676-.305-.851-.545a1.275 1.275 0 01-.266-.774c0-.224.048-.422.143-.593.096-.17.224-.32.384-.438.16-.122.34-.213.553-.277.213-.064.436-.091.67-.091.118 0 .24.005.357.021.122.016.234.038.346.06.106.026.208.052.303.085.096.032.17.064.224.096a.46.46 0 01.16.133.289.289 0 01.047.176v.251c0 .112-.042.171-.122.171a.552.552 0 01-.202-.064 2.427 2.427 0 00-1.022-.208c-.303 0-.543.048-.708.15-.165.1-.25.256-.25.475 0 .149.053.277.16.379.106.101.303.202.585.293l.756.24c.383.123.66.294.825.513.165.219.244.47.244.748 0 .23-.047.437-.138.619a1.436 1.436 0 01-.388.47c-.165.133-.362.23-.591.299-.24.075-.49.112-.761.112z"
        />
        <g
          fill={isActive ? "#F90" : "#A9A9A9"}
          fill-rule="evenodd"
          clip-rule="evenodd"
        >
          <path d="M14.465 11.813c-1.75 1.297-4.294 1.986-6.481 1.986-3.065 0-5.827-1.137-7.913-3.027-.165-.15-.016-.353.18-.235 2.257 1.313 5.04 2.109 7.92 2.109 1.941 0 4.075-.406 6.039-1.239.293-.133.543.192.255.406z" />

          <path d="M15.194 10.98c-.223-.287-1.479-.138-2.048-.069-.17.022-.197-.128-.043-.24 1-.705 2.645-.502 2.836-.267.192.24-.053 1.89-.99 2.68-.143.123-.281.06-.218-.1.213-.53.687-1.72.463-2.003z" />
        </g>{" "}
      </svg>
    ),
  },
];

export const project_list = [
  {
    heading: "Database & Machine Learning",
    details: [
      { name: "MySQL", icon: "images/MySQL.png" },
      { name: "PostgreSQL", icon: "images/PostgreSQL.png" },
      { name: "Redis", icon: "images/Redis.png" },
      { name: "TensorFlow", icon: "images/TensorFlow.png" },
    ],
  },
  {
    heading: "Mobile Technologies",
    details: [
      { name: "Swift", icon: "images/Swift.webp" },
      { name: "React Native", icon: "images/ReactNative.png" },
    ],
  },
  {
    heading: "Frontend UI",
    details: [
      { name: "jQuery", icon: "images/jQuery.png" },
      { name: "AngularJS", icon: "images/Angular.png" },
      { name: "React", icon: "images/ReactNative.png" },
    ],
  },
  {
    heading: "Web Framework",
    details: [
      { name: "Django", icon: "images/Django.webp" },
      { name: "Node.js", icon: "images/node.svg" },
      { name: "Python", icon: "images/python.webp" },
      { name: "Spring", icon: "images/Spring.png" },
    ],
  },
  {
    heading: "DevOps & Infra",
    details: [
      { name: "Kubernetes", icon: "images/Kubernetes.png" },
      { name: "Ansible", icon: "images/Ansible.png" },
      { name: "Docker", icon: "images/docker.png" },
      { name: "AWS", icon: "images/aws.png" },
    ],
  },
];

export const project_list_data = [
  {
    heading: "Healthcare",
    detail:
      "Healthcare software has become a need for today's health organizations. Leverage our custom healthcare software development services to improve patient outcomes.",
    image: "images/almana23.svg",
  },
  {
    heading: "eCommerce",
    detail:
      "We create eCommerce apps that are powerful and flexible. Our UI/UX design team makes sure your app looks great so it attracts more customers. Adapt quickly to the ever-evolving market with our custom solutions.",
    image: "images/keyki23.svg",
  },
  {
    heading: "Retail",
    detail:
      "In today's digital age, the retail industry has undergone a significant transformation, driven by advancements in information technology (IT). This transformation has not only changed the way retailers operate but has also revolutionized the shopping experience for consumers.",
    image: "images/sendoso23.svg",
  },
  {
    heading: "Banking",
    detail:
      "We help financial firms eliminate paper from their workflows and automate tedious tasks with our custom-built software. Our team also creates algorithmic apps that forecast market movements.",
    image: "images/Gigmi 5.webp",
  },
];

export const all_projects = [
  {
    name: "Sendoso",
    heading: "Retail",
    area: "Web development",
    background: "#9256DE",
    detail:
      "Sendoso helps companies stand out by giving them new ways to engage with customers throughout the buyer's journey.",
    image: "images/wb02.webp  ",
    date: "19 March 2016",
    clientname: "chris",
        background_image:"images/bg01.webp",
    text_color:"white",
    view_caseStudy:true
  },
  {
    name: "Almana General Hospital",
    heading: "Healthcare",
    area: "Web development",
    background: "#56C6DE",
    detail:
      "Almana General Hospital has been dedicated to bringing standard-setting healthcare.",
    image: "images/home02.webp",
    date: "15 March 2021",
    clientname: "Shater Abdurahman",
      background_image:"images/bg02.webp",
    text_color:"black",
    view_caseStudy:true
  },
  {
    name: "Gigmi",
    heading: "eCommerce",
    area: "Mobile development",
    background: "#f47e09",
    detail:
      "Gigmi was for making a bridge between a Contractor and a Tradesman.",
    image: "images/home01.webp",
    date: "15 Feb 2022",
    clientname: "Altholy Harvey",
    background_image:"images/bg01.webp",
    text_color:"white",
    view_caseStudy:true
  },
  {
    name: "Smrtcom",
    heading: "eCommerce",
    area: "Mobile development",
    background: "#FF5D52",
    detail:
      "Our facility management system optimizes operations for companies of all sizes, featuring maintenance scheduling, inventory, space management, and energy tracking to enhance productivity and reduce costs. With advanced technology and a user-friendly design, it ensures efficient resource use and a safe work environment.",
    image: "images/home03.webp",
    date: "15 August 2021",
    clientname: "Shater Abdurahman",
      background_image:"images/bg02.webp",
    text_color:"black",
    view_caseStudy:false
  },

  {
    name: "99DPF",
    heading: "Retail",
    area: "Mobile development",
    background: "#f47e09",
    detail:
      "Our system offers specialized management for DPF cleaning services, ensuring efficient, effective solutions for optimal vehicle emissions performance and environmental compliance. From routine maintenance to advanced cleaning, we’re here to support your needs.",
    image: "images/99dpf.webp",
    date: "15 Feb 2022",
    clientname: "Altholy Harvey",
    background_image:"images/bg01.webp",
    text_color:"white",
    view_caseStudy:false
  },
  {
    name: "KEYKI",
    heading: "eCommerce",
    area: "Mobile development",
    // background: "white",
    detail:
      "Keyki is an Online Shopping Platform introduced in Pakistan that allows you to Shop Millions of Products with Best Online Shopping Discounts.",
    image: "images/tt01.webp",
    date: "15 july 2021",
    clientname: "Ahmed Shahzad",
      background_image:"images/bg02.webp",
    text_color:"black",
    view_caseStudy:true
  }
];

export const made_off = [
  {
    type: "Knowledge",
    image: "images/Usama.jpg",
    name: "Usama Riaz",
    designation: "Software Engineer",
    quote:
      "I feel the people I'm working with here have my best interest at heart. Development has been my passion for some time now, but what's passion without knowledge? I'm learning something new here everyday. At my own pace, no pressure",
  },
  {
    type: "friendship",
    image: "images/Hassem.jpg",
    name: "Hassem Mehboob",
    designation: " Software Engineer",
    quote:
      "Friendship in an IT company is like the perfect code—strong connections, seamless collaboration, and endless debugging support, crafting a masterpiece of innovation and success.",
  },
  {
    type: "inclusivity",
    image: "images/Shahrukh.jpg",
    name: "Shahrukh Azhar",
    designation: "Product Designer",
    quote:
      "Inclusivity in an IT company is the code that unlocks infinite possibilities, embracing diversity as the key to innovation, collaboration, and a brighter future for all",
  },
  {
    type: "smiles",
    image: "images/Moaz.jpg",
    name: "Mouaz Akhtar ",
    designation: "SDR",
    quote:
      "Smiles are the universal language of the IT realm, bridging connections between teams. A single smile has the power to brighten the digital landscape and ignite a contagious enthusiasm that fuels creativity and success",
  },
  {
    type: "football",
    image: "images/omair.png",
    name: "Omair Shahid Nagi ",
    designation: "HR & Operations",
    quote:
      "Football and IT share a common spirit—teamwork, strategy, and relentless pursuit of goals. In the realm of technology, we assemble our digital squad, execute precision plays, and celebrate victories, knowing that the power of collaboration drives us to score remarkable achievements.",
  },
];

export const blogs_list_data = [
  {
    heading: "Microservices For Frontend Architecture",
    image: "images/P1-1200x800.webp",
    date: "25 May 2022",
    color: "#FF5D52",
    id: 1,
  },
  {
    heading: "How to Inject HTML into React Using IFrame",
    image: "images/P4-1200x800.webp",
    date: "25 June 2020",
    color: "#9256DE",
    id: 2,
  },
  {
    heading: "How to Convert Redux to Use React Hooks",
    image: "images/P5-1200x800.webp",
    date: "1 March 2020",
    color: "#FFC700",
    id: 3,
  },
];

export const project_types = [
  {
    name: "All",
  },
  {
    name: "Healthcare",
  },
  {
    name: "Retail",
  },
  {
    name: "eCommerce",
  },
];

export const product_details = [
  {
    carosal: {
      name: "Sendoso",
      detail:
        "Sendoso helps companies stand out by giving them new ways to engage with customers throughout the buyers journey.",
      image: "images/Sendoso 2.webp",
    },
    client: [
      {
        heading: "Clinet Name",
        name: "Sendoso",
      },
      {
        heading: "Industry",
        name: "Retail",
      },
      {
        heading: "Time Spent",
        name: "3 months",
      },
      {
        heading: "Tags",
        name: ".Net, UI/UX ",
        border: true,
      },
    ],
    challenge_details:
      "At the start of Sendoso, they faced three significant obstacles: Wearhouse issues, Team Scaling and Tech Expertise. We offer the best solutions!",
    challenge_image: "images/Sendoso.jpg",
    solution_steps: [
      {
        heading: "step1",
        details:
          "Pikes Soft provided the complete technical team including software developers, QA engineers and UI/UX designers to Sendoso at the time of starting the project.",
        image: "images/Sendoso 3.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "step2",
        details:
          "Initially there were only 6 developers.After 3 years, we helped them to scale the team to 125+ software engineers and make the company entirely remote.And the same partner acquires one of our development offices.",
        image: "images/Sendoso 1.jpg",
        background_image: "images/Polygon 7.png",
      },
      {
        heading: "step3",
        details:
          "We provided complete after-sales technical support to Sendoso for almost 2 years before it became a separate entity.",
        image: "images/Sendoso 4.jpg",
        background_image: "images/Polygon 6.png",
      },
    ],
  },
  {
    carosal: {
      name: "KEYKI",
      detail:
        "B2c & B2Nb video-based e-commerce marketplace. We enable new online businesses in a single day by providing an opportunity to buy operational single product online stores instantly",
      image: "images/Keyki 1.jpg",
    },
    client: [
      {
        heading: "Client Name",
        name: "Ahmad Shahzad",
      },
      {
        heading: "Indusrty ",
        name: "E-commerce",
      },
      {
        heading: "Time Spent",
        name: "2 Years",
      },
      {
        heading: "Tags",
        name: "React Native, UI/UX ",
        border: true,
      },
    ],
    challenge_details:
      "We had to merge the eCommerce market with the TikTok app and give them both experiences in one application. Had to design wireframes such that we can provide the right experience to the audience of both ecommerce as well as TikTok .Had to divide the Products in specific categories so user can easily filter out the specific product",
    challenge_image: "images/Keyki 2.jpg",
    solution_steps: [
      {
        heading: "Step 1",
        details:
          "There are many ecommerce projects available online but we had to make Keyki different from others by introducing a video based user experience in ecommerce market, previously user could only view the images of available products but in Keyki we introduced the video based dynamic user experience in mobile app.",
        image: "images/Keyki 4.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "Step 2",
        details:
          "Categorized products into Specific Categories so it would also help out in filtering the products.",
        image: "images/Keyki 3.webp",
        background_image: "images/Polygon 7.png",
      },
      {
        heading: "Step 3",
        details:
          "Introduced Segmented switcher to switch from video to pictures if user wants to view pictures only.",
        image: "images/Keyki 5.jpg",
        background_image: "images/Polygon 6.png",
      },
    ],
  },
  {
    carosal: {
      name: "Gigmi",
      detail:
        "Gigmi was for making a bridge between a Contractor and a Tradesman. It was previously Designed by the U.S Designer but the client wasnt quite happy with the designs and user flow. So as a good gesture we propose a new design with improved UX and a new interface look",
      image: "images/Gigmi 4.jpg",
    },
    client: [
      {
        heading: "Client Name",
        name: "Anthony Harvey",
      },
      {
        heading: "Indusrty ",
        name: "E-commerce",
      },
      {
        heading: "Time Spent",
        name: "2+ Years",
      },
      {
        heading: "Tags",
        name: "React Native, UI/UX ",
        border: true,
      },
    ],
    challenge_image: "images/Gigmi 1.jpg",
    challenge_details:
      "We had to define a design system and create a User journey but as the first release was launched and we had to stick with the same logo and color scheme as it was requested by the client that original identity of the app dont lost in revamping the current design. So we had to stick with same logo and color scheme with New Interface look. We had to keep all the risks involve and the target audience as well. challengle_image",
    solution_steps: [
      {
        heading: "Step 1",
        details:
          "User-friendly Interface: We will design an intuitive and user-friendly interface that makes it easy for Contractors and Tradesmen to create profiles, search for relevant projects or services, and communicate effectively.",
        image: "images/Gigmi 2.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "Step 2",
        details:
          "Project Management: Our platform will offer robust project management tools, allowing users to create, manage, and track projects from start to finish. This includes features such as task assignment, progress tracking, and real-time collaboration.",
        image: "images/Gigmi 3.jpg",
        background_image: "images/Polygon 7.png",
      },
      {
        heading: "Step 3",
        details:
          "Secure Payment System: We will integrate a secure payment system that enables hassle-free transactions between Contractors and Tradesmen. This will include options for milestone-based payments, escrow services, and automated invoicing for improved financial management.",
        image: "images/Gigmi 5.webp",
        background_image: "images/Polygon 6.png",
      },
    ],
  },
  {
    carosal: {
      name: "eServices",
      detail:
        "AGH - eServices mobile application allows users to view and apply for leaves (short, annual, rejoining), view their profile, attendance, entitlement, payroll, apply for online tickets, approve leaves and online tickets, and track their leaves.",
      image: "images/Almana 4.jpg",
    },
    client: [
      {
        heading: "Client Name",
        name: "SHATER ABDURAHMAN",
      },
      {
        heading: "Indusrty ",
        name: "Healthcare",
      },
      {
        heading: "Time Spent",
        name: "3+ Years",
      },
      {
        heading: "Tags",
        name: "React, .Net, Figma ",
        border: true,
      },
    ],
    challenge_details:
      "Need to make a user-friendly design as most of the users were new to the automation system and not familiar to apply for online leave. Tracking of online application for the user to see the current status of their application, whether it is approved or rejected or in the way of the process.",
    challenge_image: "images/Almana 1.jpg",
    solution_steps: [
      {
        heading: "Step 1",
        details:
          "This application is basically used for almana employees as they have over 6500+ employees and more than 800+ doctors in around 8 medical facilities so it was very difficult for the organization to keep track all of them manually.",
        image: "images/Almana 3.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "Step 2",
        details:
          "The main menu was designed simple so everyone can use the app accordingly. All Main options were placed on the home dashboard where everyone can access it easily.",
        image: "images/Almana 5.jpg",
        background_image: "images/Polygon 7.png",
      },
      {
        heading: "Step 3",
        details:
          "All Employees can check their previous leaves and annual leaves left, also their check-in time at the hospital",
        image: "images/Almana 2.jpg",
        background_image: "images/Polygon 6.png",
      },
    ],
  },

  {
    carosal: {
      name: "Almana General Hospital",
      detail:
        "Since 1945, Almana General Hospital has been dedicated to bringing standard-setting healthcare. The first private general hospital in the Eastern Provence and, one of the oldest and largest medical company in Gulf Region, AGH continue its tradition of excellence today.",
      image: "images/almana.png",
    },
    client: [
      {
        heading: "Client Name",
        name: "SHATER ABDURAHMAN",
      },
      {
        heading: "Indusrty ",
        name: "Healthcare",
      },
      {
        heading: "Time Spent",
        name: "3+ Years",
      },
      {
        heading: "Tags",
        name: "React, NodeJS Figma ",
        border: true,
      },
    ],
    challenge_details:
      "The Challenging part for us was to change the UI and client stream of currently made application with a similar functionality. We had to map out all the functionalities which were in the previous app should also be accommodated in the New design and Components. We had to improve the user experience by keeping the target audience in mind .",
    challenge_image: "images/hospital5.jpg",
    solution_steps: [
      {
        heading: "Step 1",
        details:
          "In Previous Design, there was a major issue of User Journey and it was very difficult for the user to explore all the options available. There was no Search Option Available if the user want to explore or visit any specific doctor, he has to click on the option of book an appointment to reach the expected result",
        image: "images/Home Screen.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "Step 2",
        details:
          "We revamp the design according to Modern UI and minimalized the screens as much as we could",
        image: "images/Digilab.jpg",
        background_image: "images/Polygon 6.png",
      },
      {
        heading: "Step 3",
        details:
          "Keeping in mind the challenges we had we improve the Search navigation so the patient can explore maximum results. Designed bottom navigation for the user to allow quick access to the profile, appointments & Inbox",
        image: "images/hospital4.jpg",
        background_image: "images/Polygon 6.png",
      },
    ],
  },
];
export const service_details = [
  {
    carosal: {
      type: "Healthcare",
      name: "Mobile Development",
      detail:
        "We provide 360 solutions ranging from communication, social networking, and entertainment mobile apps for Android and iOS",
      image: "images/Almana 3.jpg",
    },
    product_heading:
      "Mobile development services to build innovative experiences",
    product_details:
      "Undertake a modernized technique toward cellular application development with Pikessoft – the main Mobile development agency. We deliver high-overall performance, function-packed cellular reviews for cell gadgets, wearables, IoT, or augmented truth gadgets.",
    project_details: {
      Heading: "Mobile Development Services",
      details:
        "End-to-end conceptualization, design, and support for your mobile app",
      list: [
        {
          image: "images/img_androidsvgrepocom.svg",
          title: "Andriod",
          subHeading:
            "Combine custom tech solutions and business objectives to reach the world’s largest app market ",
        },
        {
          image: "images/img_applesvgrepocom.svg",
          title: "IOS",
          subHeading:
            "We create well-designed agile development across all iOS platforms",
        },
        {
          image: "images/img_location_black_900.svg",
          title: "Flutter",
          subHeading:
            "Develop for multiple devices to achieve higher market penetration, with React Native or Flutter",
        },
      ],
    },
    experties: {
      image1: "images/Android.svg",
      image2: "images/IOS.svg",
      image3: "images/React.svg",
      image4: "images/Flutter.svg",
    },
  },
  {
    carosal: {
      type: "Retail",
      name: "Web Development",
      detail:
        "Having been in the business for over a decade, we love to convert your ideas into reality and fulfilling your dreams by offering a scalable solution.",
      image: "images/Almana 2.jpg",
    },
    product_heading:
      "Web application company offering a fully-optimized solution",
    product_details:
      "Pikessoft Website Application Company specializes in custom website design and development. For businesses, our website designers and developers create enterprise-level websites and web portals.",
    project_details: {
      Heading: "Web Development Services",
      details:
        "Client-focused and customer-centric website solutions that deliver tangible business results",
      list: [
        {
          image: "images/img_nodejssvgrepocom.svg",
          title: "Node.js",
          subHeading:
            "Build lightweight real-time applications based on a microservice architecture",
        },
        {
          image: "images/img_clock_black_900.svg",
          title: "Ruby on Rails",
          subHeading:
            "Create new functionalities for your existing system, or tackle technical issues.",
        },
        {
          image: "images/img_python127svgrepocom.svg",
          title: "Python",
          subHeading:
            "Create powerful web apps using less code and integrate their scripts with other languages.",
        },
      ],
    },
    experties: {
      image1: "images/Java.svg",
      image2: "images/img_nodejsicon1.svg",
      image3: "images/img_image69.png",
      image4: "images/Angular.svg",
    },
  },
  {
    carosal: {
      type: "eCommerce",
      name: "Product Design",
      detail:
        "We apply collaborative, human-centered design thinking to even the toughest of business challenges. With a relentless commitment to innovation and world-class craftsmanship, we deliver the most beautiful, meaningful and impactful experiences for your customers",
      image: "images/Keyki 1.jpg",
    },
    product_heading:
      "Pikes Soft Pivots On A Solid Foundation, One That Is Built On Your Vision & Our Expertise.",
    product_details:
      "Pikes Soft has a proven track record of delivering impactful customer experiences, unlocking the power of technology within organizations, and stimulating growth with brave new initiatives",
    project_details: {
      Heading: "Product Design Services ",
      details:
        "Ideation and creation of software products across every stage of the life cycle",
      list: [
        {
          image: "images/img_svgfreepiksto.svg",
          title: "User Experience",
          subHeading:
            "We create products that provide meaningful and relevant experiences to users.",
        },
        {
          image: "images/img_computer_gray_900_03.svg",
          title: "User Interface",
          subHeading:
            "Create new functionalities for your existing system, or tackle technical issues.",
        },
        {
          image: "images/img_branding.svg",
          title: "Branding",
          subHeading:
            "We create a digital presence uniquely marketed to optimize reach and sales.",
        },
      ],
    },
    experties: {
      image1: "images/Maze.svg",
      image2: "images/Miro.svg",
      image3: "images/Adobe Xd.svg",
      image4: "images/Figma.svg",
    },
  },
  {
    carosal: {
      type: "eCommerce",
      name: "DevOps",
      detail:
        "Our engineers examine key pain points, suggest gear and implement techniques to automate deployment cycle and improve infrastructure.",
      image: "images/img_frame7469.png",
    },
    product_heading: "Enhance Your IT Team’s Performance with DevOps",
    product_details:
      "Devops answers automate away inefficiencies and enhance the high-quality and protection of software. Pikessoft devops consulting services assist corporations optimize their it group’s performance. ",
    project_details: {
      Heading: "DevOps Services",
      details:
        "Iterative and incremental development promoting increased agility and enhanced quality.",
      list: [
        {
          image: "images/img_3669450assessmenticicon.svg",
          title: "Assessment",
          subHeading:
            "Evaluate enhanced capabilities and provide a visualisation of your transformation journey.",
        },
        {
          image: "images/img_settings.svg",
          title: "Automation",
          subHeading:
            "Reduce human assistance to processes that facilitate feedback loops between various teams.",
        },
        {
          image: "images/img_subaccountssvgrepocom.svg",
          title: "Management",
          subHeading:
            "Maintain and execute organizational procedures for configuration and release management.",
        },
      ],
    },
    experties: {
      image1: "images/img_image63.png",
      image2: "images/img_image64.png",
      image3: "images/img_image65.png",
      image4: "images/img_image66.png",
    },
  },
  {
    carosal: {
      type: "Healthcare",
      name: "Quality Assurance",
      detail:
        "Our enthusiastic squad of well equipped personals helps you build reliable products by offering Performance and Security Testing, Mobile and Manual Testing",
      image: "images/almana-hospital-3.jpg",
    },
    product_heading: "Let’s Make Your Product Reliable",
    product_details:
      "We offer stop-to-give-up checking out services at each step of the software program development lifecycle to make sure all included portions of answers are performing as designed from the start to complete.",
    project_details: {
      Heading: "Quality Assurance Services",
      details:
        "Safeguard your product’s quality by managing risks and preventing flaws and issues.",
      list: [
        {
          image: "images/img_performanceup.svg",
          title: "Performance Testing",
          subHeading:
            "Evaluate system performance with responsiveness and stability under a particular workload.",
        },
        {
          image: "images/img_securityverifi.svg",
          title: "Security Testing",
          subHeading:
            "Reveal flaws in the security mechanisms of an information system that protect data.",
        },
        {
          image: "images/img_upload.svg",
          title: "Test Automation",
          subHeading:
            "Test software and other tech products to ensure it meets strict requirements.",
        },
      ],
    },
    experties: {
      image1: "images/Java.svg",
      image2: "images/img_nodejsicon1.svg",
      image3: "images/img_image69.png",
      image4: "images/Angular.svg",
    },
  },
];

export const service_list = [
  {
    name: "Mobile_App_Development",
    heroHeading: "Mobile App Development Services",
    heroSubHeading:
      "Pikes Soft is the name behind products that have collected over millions of doller in revenue, received funding, and frequently made it to the stores’ featured lists. We are the world’s favorite Mobile app development service providers.",
    heading: "Mobile App Development",
    detail:
      "Building custom software solutions that run seamlessly across device and operating systems.",
    navigateTo: "Mobile Development",
    vector: "images/vector01.png",
    images: [
      {
        image: "images/mb01.webp",
      },
      {
        image: "images/mb02.webp",
      },
      {
        image: "images/mb03.webp",
      },
      {
        image: "images/mb04.webp",
      },
      {
        image: "images/mb05.webp",
      },
    ],
    color: "#56DE7D",
    techArray: [
      {
        image: <FaApple className="h-[15px] w-[15px]" />,
        title: "iOS Development",
        subHeading:
          "Helping businesses enjoy more app earnings and strong security with our well-planned iOS app development services.",
      },
      {
        image: <TbDeviceMobileCode className="h-[15px] w-[15px]" />,
        title: "Native App Development",
        subHeading:
          "We bring extensive experience to every part of native app development. Our specialty is crafting custom native applications that align perfectly with your business needs and goals, ensuring your success.",
      },
      {
        image: <TbDeviceMobilePlus className="h-[15px] w-[15px]" />,
        title: "Cross-platform mobile app development services",
        subHeading:
          "Our expert team builds robust, scalable mobile apps that set new industry standards. We specialize in custom app development tailored to market needs, your goals, and the latest tech advancements.",
      },

      {
        image: <AiFillAndroid className="h-[15px] w-[15px]" />,
        title: "Android Development",
        subHeading:
          "Android is known as the ecosystem for startups and firms that keep creativity and scalability as their center focus. We serve the digital space with Android app development services known to increase customer engagement, better brand awareness, simplify customization, and strengthen security in the digital space.",
      },
      {
        image: <SiFlutter className="h-[15px] w-[15px]" />,
        title: "Flutter Development",
        subHeading:
          "Startups love Flutter for its affordability, and big companies use it for rapid growth. At Pikes Soft, we help both succeed with our expert Flutter app services.",
      },
      {
        image: <TbBrandReactNative className="h-[15px] w-[15px]" />,
        title: "React Native Development",
        subHeading:
          "Accelerate your business growth with our React Native app services. Our expert developers create custom apps for both iPhone and Android, tailored to your business needs.",
      },
    ],
  },
  {
    name: "Web_App_Development",
    heroHeading: "Web Application Development",
    heroSubHeading:
      "We're a company that focuses on creating strong and scalable web solutions through custom web application development services.",
    heading: "Website Application Development",
    detail:
      "Helping businesses at every step of their digital journey, like being part of their team.",
    navigateTo: "Web Development",
    vector: "images/vector02.png",
    images: [
      {
        image: "images/wb01.webp",
      },
      {
        image: "images/wb02.webp",
      },
      {
        image: "images/wb03.webp",
      },
      {
        image: "images/wb04.webp",
      },
      {
        image: "images/wb03.webp",
      },
    ],
    color: "#DE568F",
    techArray: [
      {
        image: <FaLaptopCode className="h-[15px] w-[15px]" />,
        title: "Web App Development",
        subHeading:
          "We're a company that focuses on creating strong and scalable web solutions through custom web application development services.",
      },
      {
        image: <FaLaptopCode className="h-[15px] w-[15px]" />,
        title: "Web Portal Solutions",
        subHeading:
          "We design feature-rich web portals with intuitive interfaces and powerful collaboration tools to enhance user engagement.",
      },
      {
        image: <FaLaptopMedical className="h-[15px] w-[15px]" />,
        title: "Custom Web Apps",
        subHeading:
          "Our custom web app solutions are flexible, user-friendly, and optimized for your specific business needs across devices and platforms.",
      },
      {
        image: <BsCloudArrowUpFill className="h-[15px] w-[15px]" />,
        title: "Cloud-Based Web Apps",
        subHeading:
          "Partnering with AWS and Azure, we develop customizable cloud-based web apps that scale with your business seamlessly.",
      },
      {
        image: <FaLaptopCode className="h-[15px] w-[15px]" />,
        title: "Dynamic Web Applications",
        subHeading:
          "We design dynamic web apps that offer real-time updates and personalized content, ensuring an interactive user experience.",
      },
      {
        image: <CgWebsite className="h-[15px] w-[15px]" />,
        title: "Single-Page Web Applications",
        subHeading:
          "Our SPAs offer fast-loading, dynamic experiences using advanced tools like React.js for seamless user interaction.",
      },
      {
        image: <CgWebsite className="h-[15px] w-[15px]" />,
        title: "Enterprise Web Applications",
        subHeading:
          "We develop robust web applications for enterprises, including ERP systems, CRM software, project management tools, financial management solutions, and collaboration platforms. ",
      },
      {
        image: <CgWebsite className="h-[15px] w-[15px]" />,
        title: "eCommerce Web Applications",
        subHeading:
          "Transform your website into a vibrant online marketplace with our eCommerce web app development services. We specialize in building secure, scalable, and user-friendly eCommerce platforms tailored to your business needs.",
      },
    ],
  },
  {
    name: "AI_ML_Development",
    heroHeading: "AI/ML Services ",
    heroSubHeading:
      "It’s time for change, Solving What Matters with AI Pikes Soft AI development services help businesses improve their decision-making and automate business operations and workflows.Combining industry expertise and the latest IT advancements, Pikes Soft offers comprehensive machine learning development services to create custom ML solutions that automate business processes and improve decision-making.",
    heading: "AI/ML Services",
    detail:
      "Powering digital products with time-tested and new-gen technologies.",
    navigateTo: "Product Design",
    vector: "images/vector03.png",
    images: [
      {
        image: "images/ai01.webp",
      },
    ],
    color: "#DEC056",
    techArray: [
      {
        image: <GiRobotAntennas className="h-[15px] w-[15px]" />,
        title: "Artificial Intelligence",
        subHeading:
          "AI Solutions Tailored for Business Success Our AI development solutions streamline your business processes and effortlessly tackle complex challenges. As a top Artificial Intelligence Development Company, we specialize in launching powerful AI software to elevate your business.",
      },
      {
        image: <GiTv className="h-[15px] w-[15px]" />,
        title: "Computer Vision",
        subHeading:
          "Our AI development team has extensive experience in creating solutions for object recognition and image classification. We utilize Amazon Recognition and deep learning for powerful visual search capabilities.",
      },
      {
        image: <GiTv className="h-[15px] w-[15px]" />,
        title: "Natural Language Processing",
        subHeading:
          "At Pikes Soft, our AI experts use NLP (Natural Language Processing) and NLU (Natural Language Understanding) to help businesses analyze customer feedback. This enables enhanced customer engagement and increased business profits.",
      },
      {
        image: <TbDeviceImacCog className="h-[15px] w-[15px]" />,
        title: "Large Language Models- LLM",
        subHeading:
          "Predictive analytics helps your firms by offering valuable insights about future events using data and statistical algorithms based on the available historical data.",
      },
      {
        image: <SiOpenai className="h-[15px] w-[15px]" />,
        title: "Openai ChatGPT",
        subHeading:
          "With the help of AI technologies, our video analytics solutions use video surveillance systems to extract accessible, usable, and measurable information from live or stored video footage.",
      },

      {
        image: <GiRobotAntennas className="h-[15px] w-[15px]" />,
        title: "Generative AI",
        subHeading:
          "At Pikes Soft, we offer OCR services that help you to recognize text and characters from scanned documents, photographs as well as digital camera-captured images.",
      },
      {
        image: <FaLink className="h-[15px] w-[15px]" />,
        title: "Deep Learning Services",
        subHeading:
          "At Pikes Soft, we offer OCR services that help you to recognize text and characters from scanned documents, photographs as well as digital camera-captured images.",
      },
      {
        image: <GiTv className="h-[15px] w-[15px]" />,
        title: "AI as a Services",
        subHeading:
          "At Pikes Soft, we offer OCR services that help you to recognize text and characters from scanned documents, photographs as well as digital camera-captured images.",
      },

      {
        image: <GiRobotAntennas className="h-[15px] w-[15px]" />,
        title: "ML Consulting & Strategy Building",
        subHeading:
          "If you aim to streamline processes, enhance customer experiences, or gain a competitive edge with ML, our expertise is your solution. We evaluate your current tech setup, identify ML integration opportunities, and craft customized strategies for seamless ML solution implementation.",
      },
      {
        image: <FaLink className="h-[15px] w-[15px]" />,
        title: "MLOps Consulting",
        subHeading:
          "We help organizations in adopting MLOps best practices, optimizing workflows for faster and more reliable ML model development and deployment.",
      },
      {
        image: <GiTv className="h-[15px] w-[15px]" />,
        title: "Data Engineering",
        subHeading:
          "Our data engineering service guarantees high-quality data tailored for machine learning model training. We offer a comprehensive suite of tasks, including data collection, cleaning, feature engineering, and augmentation, ensuring your data is appropriately prepared for specific ML tasks.",
      },
      {
        image: <TbDeviceImacCog className="h-[15px] w-[15px]" />,
        title: "Custom ML Model Development",
        subHeading:
          "We specialize in developing domain-specific ML models by fine-tuning pre-trained ones to suit your business needs. Whether it's BERT, GPT, or Llama 2, our expert team ensures your models provide context-aware responses with the highest accuracy and precision.",
      },
      {
        image: <GrTechnology className="h-[15px] w-[15px]" />,
        title: "ML-powered Solutions Development",
        subHeading:
          "Our team of data scientists and AI developers creates ML solutions to match your specific requirements. We excel in creating personalized predictive models, recommendation systems, and data-driven applications.",
      },
    ],
  },
  {
    name: "Blockchain_Development",
    heroHeading: "Blockchain Development",
    heroSubHeading:
      "Elevate your business success with our custom blockchain development services. As a blockchain app development company, we specialize in NFTs and Web 3.0 development.",
    heading: "Blockchain Development ",
    detail:
      "Elevate your business success with our custom blockchain development services.",
    navigateTo: "Web Development",
    vector: "images/vector02.png",
    images: [
      {
        image: "images/bd01.webp",
      },
      {
        image: "images/bd02.webp",
      },
      {
        image: "images/bd03.webp",
      },
    ],
    color: "#DE568F",
    techArray: [
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "Blockchain Technology Consulting",
        subHeading:
          "Our approach to blockchain consulting begins with what, why, and how blockchain technology can benefit your enterprise solution and bring trust and transparency to the system.",
      },
      {
        image: <RiNftFill className="h-[15px] w-[15px]" />,
        title: "NFT Marketplace Development",
        subHeading:
          "We help businesses build their protocol-specific decentralized NFT games development company to organize NFT trading, bidding, and selling digital assets.",
      },
      {
        image: <FaWallet className="h-[15px] w-[15px]" />,
        title: "Crypto Wallet Development",
        subHeading:
          "We are a crypto wallet development company that expands your business's DeFi portfolio, ensuring enhanced security and faster transactions for a wider customer base. Our expert blockchain developers craft and launch your crypto wallet with essential features like QR scanning, biometric authentication, and seamless cross-platform functionality.",
      },
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "Blockchain Supply Chain Development",
        subHeading:
          "We develop, deploy and manage blockchain supply chain solutions that offer complete transparency at every step of the product’s journey and help eliminate communication gaps and data-transfer errors.",
      },
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "Custom Blockchain App Development",
        subHeading:
          "With expertise in various blockchain platforms like Tezos, Hyperledger, Polkadot, Tron, Stellar, and EOS, we build scalable and robust custom blockchain software solutions for enterprises and startups.",
      },
      {
        image: <CgWebsite className="h-[15px] w-[15px]" />,
        title: "Smart Contracts Development",
        subHeading:
          "Our smart contract development includes developing and deploying self-executing contracts for public and private blockchain networks. We have expertise in building smart contracts for crowdfunding, blockchain supply chain solutions, NFT projects, and diverse dApps.",
      },
      {
        image: <CgWebsite className="h-[15px] w-[15px]" />,
        title: "Decentralized Exchange ",
        subHeading:
          "Our blockchain application development team creates hack-proof and robust decentralized exchange platforms on Android and iOS to enable the real-time exchange of digital currencies securely and efficiently.",
      },
      {
        image: <FaWallet className="h-[15px] w-[15px]" />,
        title: "Blockchain Wallet Development",
        subHeading:
          "Our blockchain developers build robust and feature-rich web and mobile wallet applications that support the exchange of various digital assets and currencies and are integrated with features of cross-chain token swapping.",
      },
      {
        image: <GiToken className="h-[15px] w-[15px]" />,
        title: "Tokenization",
        subHeading:
          "Our blockchain development team can help you tokenize any asset you want, ensuring trust, transparency and efficiency. Tokenization eliminates volatility and brings more liquidity to a wide array of assets.",
      },
    ],
  },
  {
    name: "OTT_App_Development",
    heroHeading: "OTT Platform Development",
    heroSubHeading:
      "Pikes Soft specializes in creating and advancing video and audio streaming applications featuring an integrated in-app payment system. If you're a content creator looking to make your content through your OTT App platform, don't hesitate to get in touch with us.",
    heading: "OTT Platform Development ",
    detail:
      "If you're a content creator looking to make your content through your OTT App platform, don't hesitate to get in touch with us.",
    navigateTo: "Web Development",
    vector: "images/vector02.png",
    images: [
      {
        image: "images/tt01.webp",
      },
    ],
    color: "#56DE7D",
    techArray: [
      {
        image: <FaLaptopCode className="h-[15px] w-[15px]" />,
        title: "Custom OTT App Development",
        subHeading:
          "As a leading OTT software development service company, we design and develop robust custom video streaming platforms that give your business complete control over the user account, interface, and content.",
      },
      {
        image: <GiPencilBrush className="h-[15px] w-[15px]" />,
        title: "OTT UI & UX Design",
        subHeading:
          "Our OTT platform's UX/UI design prioritizes great usability, user experience, and visually captivating elements to engage users effectively. Utilize our frontend expertise for building high-end professional-looking user interfaces for various devices and screens.",
      },
      {
        image: <RxUpdate className="h-[15px] w-[15px]" />,
        title: "OTT Application Migration and Upgrade",
        subHeading:
          "We follow a seamless strategy for migrating and upgrading OTT apps, driven by a customer-centric approach and a vision for long-term innovation. With our team of OTT application development experts, we facilitate smooth transitions from legacy platforms to exceptional viewing experiences.",
      },
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "OTT Application Integration",
        subHeading:
          "With a seamless and consistent strategy, our custom OTT solution development experts can effectively help you with your OTT-related initiatives. When it comes to integration requirements, our highly competent team ensures exceptional results with unparalleled ease.",
      },
      {
        image: <BiSupport className="h-[15px] w-[15px]" />,
        title: "OTT Maintenance and Support",
        subHeading:
          "We provide ongoing support extending beyond the conventional migration or deployment process of any specific OTT platform. This includes addressing application threats and bugs, securing databases, and fine-tuning checkpoints to guarantee a robust OTT streaming platform.",
      },
    ],
  },
  {
    name: "Cloud_App_Development",
    heroHeading: " Cloud Application Development ",
    heroSubHeading:
      "Want to update your business setup and improve user experience? Pikes Soft offers skilled cloud app development services, solving issues like scalability and security. We use AWS, Azure, and Google Cloud Platform to make operations smoother and improve online visibility.",
    heading: " Cloud Application Development  ",
    detail:
      " Pikes Soft offers skilled cloud app development services, solving issues like scalability and security. ",
    navigateTo: "Web Development",
    vector: "images/vector02.png",
    images: [
      {
        image: "images/home01.webp",
      },
      {
        image: "images/home02.webp",
      },
      {
        image: "images/home03.webp",
      },
    ],
    color: "#DEC056",
    techArray: [
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "Cloud consulting",
        subHeading:
          "We help businesses in making plans for using cloud technology. Our team looks at everything from how the cloud system will be set up to how it will be used, making sure it's done efficiently. We also check your current system to see how it can be connected to the cloud without causing any interruptions.",
      },
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "Cloud application development",
        subHeading:
          "We offer complete cloud development services. Whether you need help with planning and moving your apps to the cloud or building a new cloud-based app from the ground up, our team can handle it all smoothly",
      },
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "Cloud integration",
        subHeading:
          "Our cloud experts make sure everything works smoothly when we connect different systems and networks. They ensure data moves between systems without any problems. No matter the project, our goal is always to make businesses work better using technology.",
      },
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "Cloud re-architecting",
        subHeading:
          "At Pikes Soft, our cloud experts are skilled at updating old applications. We improve them to meet the industry's future needs and what users want now. We gather resources and parts from different places in the network to make sure your old software can work in the cloud.",
      },
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "SaaS Implementations",
        subHeading:
          "We create software products using cloud technology for top performance, scalability, and accessibility. Our certified architects ensure easy user experience and management for all SaaS projects.",
      },
      {
        image: <TbCloudComputing className="h-[15px] w-[15px]" />,
        title: "Cloud managed services",
        subHeading:
          "We focus on using cloud services first. We handle your use of different cloud platforms like Azure and AWS. Our experts are very familiar with these platforms and can help you update your apps smoothly without any issues.",
      },
      {
        image: <BiSupport className="h-[15px] w-[15px]" />,
        title: "Cloud maintenance and support",
        subHeading:
          "As a well-known cloud app development company, we use top tools and methods to make sure your app runs smoothly. When you work with us, you get a team that checks for and fixes problems right away, so they don't disrupt your business or make customers unhappy.",
      },
    ],
  },
  {
    name: "DevOps_Consulting",
    heroHeading: " Devops Consulting ",
    heroSubHeading:
      "Speed up getting your product to market by fixing delays and working together using DevOps solutions that connect your software and operations teams.",
    heading: "Devops Consulting",
    detail:
      " Speed up getting your product to market by fixing delays and working together using DevOps solutions that connect your software and operations teams. ",
    navigateTo: "Web Development",
    vector: "images/vector02.png",
    images: [
      {
        image: "images/home01.webp",
      },
      {
        image: "images/home02.webp",
      },
      {
        image: "images/home03.webp",
      },
    ],
    color: "#DE568F",
    techArray: [
      {
        image: <TiFlowChildren className="h-[15px] w-[15px]" />,
        title: "CI/CD Services",
        subHeading:
          "We follow Continuous Integration and Continuous Delivery industry standards for identifying issues right from the early stages of project development. Our team uses CI/CD tools to create, package, and then test applications in an automated way to better the project outcome.",
      },
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "Infrastructure Management",
        subHeading:
          "At Pikes Soft, our team of DevOps solutions providers evaluate your current business infrastructure, design a roadmap for process revamping, and create a completely automated IT and Operations environment that is scalable and secure.",
      },
      {
        image: <LuBoxes className="h-[15px] w-[15px]" />,
        title: "Configuration Management",
        subHeading:
          "We assist in establishing robust configuration management practices using extensive tools to ensure scalability in managing your lean operations.",
      },
      {
        image: <FaMagnifyingGlass className="h-[15px] w-[15px]" />,
        title: "Code Inspection",
        subHeading:
          "We ensure top-notch software builds by continuously inspecting and improving code quality, reducing maintenance efforts. We collaborate with your team to enhance code quality and validate deployment artifacts.",
      },
      {
        image: <PiVirtualRealityFill className="h-[15px] w-[15px]" />,
        title: "Virtualization",
        subHeading:
          "At Pikes Soft, we use virtualization capabilities to remove bottlenecks without affecting the computing resources. We build a virtual environment that enables the operations teams and developers to create an agile, scalable, and flexible development environment.",
      },
      {
        image: <MdAutoFixHigh className="h-[15px] w-[15px]" />,
        title: "DevOps Automation",
        subHeading:
          "From configuring and provisioning servers and setting up environments, firewalls to upgrades and maintenance, our DevOps services company supports you in every project lifecycle stage. We help you be more agile and efficient by identification and automation of different operations stages.",
      },
    ],
  },
];

export const Developers = [
  {
    name: "Fawad Naeem",
    image: "images/img_image50.png",
    designation: "CTO, Tech Visionary & Strategist",
    details:
      " A tech maven renowned for merging visionary leadership, always on the hunt for the next technological horizon",
       color: "#FFCC01",
    link: "https://calendly.com/shahzaib-ede/30min",
  },
  {
    name: "Sohail Mohabbat Ali",
    image: "images/sohail.jpg",
    designation: "Senior Software Architect",
    details:
      " Combines deep technical knowledge with a passion for creating efficient software. A valuable asset for any team.",
        color: "#E3285F",
    link: "https://calendly.com/shahzaib-ede/30min",
         },
  {
    name: "Shahzaib Saleem",
    image: "images/shahzab.jpg",
    designation: "Data Engineer & E-Commerce Expert",
    details:
      "A tech virtuoso in software engineering, translating innovative ideas into tangible business results.",
       color: "#00B7E9",
    link: "https://calendly.com/shahzaib-ede/30min",
  },
];

export const reviews = [
  {
    rating: 5.0,
    text: "Everyone on the team was able to voice their ideas and point out assumptions, leading to a more...",
    author: "Co-Founder, SOL Mental Health",
  },
  {
    rating: 5.0,
    text: "They didn't just regard this as a transactional project; they actually cared about our platforms...",
    author: "CEO & Co-Founder, Vertalo",
  },
  {
    rating: 5.0,
    text: "Everyone on the team was able to voice their ideas and point out assumptions, leading to a more...",
    author: "Co-Founder, SOL Mental Health",
  },
  {
    rating: 5.0,
    text: "They handled our complicated difficulties with confidence and agility",
    author: "CEO & Founder, Alleypop",
  },
  {
    rating: 4.5,
    text: "The team was very professional and delivered everything on time.",
    author: "Manager, TechCorp",
  },
  {
    rating: 4.8,
    text: "Great experience working with the team, highly recommended!",
    author: "CTO, WebX",
  },
  {
    rating: 5.0,
    text: "Amazing service, everything went smoothly!",
    author: "Founder, SoftWare Inc.",
  },
  {
    rating: 4.9,
    text: "Very pleased with the results, will hire again.",
    author: "Owner, Startup Inc.",
  },
];

export const SuccessStories_image = ['images/ss01.webp', 'images/ss02.webp', 'images/ss03.webp', 'images/ss04.webp'];
